/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ChangeEvent } from 'react';
import clsx from 'clsx';
import { StyledGuestDetails } from './GuestDetails.styles';
import { GuestDetailsProps, FormError, PetFeeData } from './GuestDetails.types';
import {
  Heading,
  Text,
  Types,
  CheckBox,
  Switch,
  Button,
  InputTextField,
  Messages,
  Calendar,
  useCheckBreakpoint,
} from '@marriott/mi-ui-library';
import { TextArea } from '../../atoms/TextArea';
import { useState, useId, useEffect, useRef } from 'react';
import { TimePicker } from '../../molecules/TimePicker';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { phoenixPrearrivalProperty } from '../../graphql';
import { PhoneNumberField } from '../../molecules/PhoneNumberField';
import { SurveyWrapper } from '../../molecules/SurveyWrapper';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// import { isServer } from '@marriott/mi-apollo-client-utils';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
import {
  ALPHABETS_REGEX,
  EMAIL_REGEX,
  transportationType,
  countriesDialTimeZone,
  brandColorSchemeGenerator,
  accessiblityDetailsCheckboxData,
  preferredContactCheckboxData,
  specialOcationCheckboxData,
  specialCheckboxData,
  CALENDAR_MAX_ALLOWED_DAYS,
  SHORT_WEEK_DAYS,
  LONG_MONTH_NAME,
  LONG_WEEK_DAYS_NAME,
  SHORT_MONTH_NAME,
} from '../../util/constants';
import DOMPurify from 'isomorphic-dompurify';
import dayjs from 'dayjs';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';
import { capitalize, removeXSSScripts, convertToPrice } from '../../util/helpers';

import { updateDatalayer } from '../../util/dataLayer/datalayerUtil';
import { ErrorDetail } from '../Error';
import { SurveyWrapperInner } from '../../molecules/SurveyWrapperInner';
// import { usePageContext } from '../../context/PageContext';
import DynamicAddSection from '../../molecules/DynamicAddSection/DynamicAddSection';
import { DynamicAddSectionRef } from '../../molecules/DynamicAddSection/DynamicAddSection.types';
import { validateStayNotStarted } from '../../util/prearrivalValidation';
import { getResConfirmationDatePrefix } from '../../util/dataLayer/resConfirmationNumberUtil';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GuestDetails: FC<GuestDetailsProps> = (props: any) => {
  // useref creates a mutable reference object that persists across renders.
  const sectionRef = useRef<DynamicAddSectionRef>(null);
  const sectionPetRef = useRef<DynamicAddSectionRef>(null);
  // const { sessionData1, isAuthorMode } = usePageContext();
  // console.log('check session data is coming or not', sessionData1);
  // console.log('check session data is coming from import comp', props?.sessionData1);
  // console.log('check isAuthorMode data is coming orset not', isAuthorMode);
  const {
    formData,
    setFormData,
    formValidation,
    validateForm,
    setFormValidation,
    setTotalPoint,
    form_prearrival_questions_complete,
  } = useCreateSurveyStore();
  const { styleClass } = props;
  const [isLoading, setIsLoading] = useState(true);
  const searchParams = useSearchParams();
  const pathName = usePathname();
  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const marshaCode: any =
    searchParams.get('marshaCode') ||
    props?.property_config?.marsha_cd ||
    formData?.property_config?.marsha_cd ||
    formData?.marsha_cd ||
    formData?.marshaCode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const marshaCode1: any = searchParams.get('marshaCode');
  const selectedLanguage = searchParams.get('language') || props?.language || 'en-US';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const confirmationNumber1: any = searchParams.get('confirmationNumber');
  const guestDetailV2: boolean = true;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updatedDetails: any = [];

  updatedDetails.push({
    contact_method_type: 'email',
    contact_method_detail: props?.reservation?.cusotmerEmail,
    timezone_of_guest: '',
  });
  let isShowError: boolean = false;
  let errorInfo: string = '';
  let errorMsg: string = props?.errorMessage ?? 'noError';

  const stayValidation = validateStayNotStarted({
    arrivalDate: props?.reservation?.arrival,
    isAuthorMode: props.isAuthorMode ?? false,
    confirmationNumber: confirmationNumber1,
    marshaCode: marshaCode1,
    errorData: props?.errorData,
    propertyConfigError: props?.property_config?.error,
    errorMessage: props?.errorMessage,
  });
  isShowError = stayValidation.isShowError;
  errorInfo = stayValidation.errorInfo;
  errorMsg = stayValidation.errorMsg;

  const handleNextPage = (newPart?: string) => {
    if (!formData?.property_config?.marsha_cd) {
      // save the marsha code and confirmation number in session storage
      setFormData({
        ...formData,
        marshaCode: marshaCode,
        confirmationNumber: confirmationNumber1,
        amenities: props?.amenities,
        property_config: props?.property_config,
        reservation: props?.reservation,
        passions: props?.passions,
        marsha_cd: marshaCode,
        reservation_num: props?.reservation?.confirmationNumber,
        preferred_contact_method_details: updatedDetails,
        favIcon: props?.favIcon,
        brandCode: props?.brandCode,
      });
    }
    // if (petFeeData?.property?.policies?.petsAllowed) {
    //   setFormData({
    //     ...formData,
    //     petFeeCatalogData: 'Y',
    //   });
    // }
    updateDatalayer('form_prearrival_questions_complete', form_prearrival_questions_complete);
    updateDatalayer('form_step_name', 'Dining');
    const currentPath = pathName;
    const newPath = currentPath.replace(/\/[^/]*$/, `/${newPart}`);
    // handleRedirect(newPath);
    router.push(newPath);
  };

  const inputId = useId();

  // need to fetch the data from load reservation
  const [firstLastName, setFirstLastName] = useState('');
  const [arrivalDate, setArrivalDate] = useState(
    moment(props?.reservation?.arrival || formData?.reservation?.arrival).format('MMM D, YYYY')
  );
  const [reservation, setReservation] = useState(null);
  const [departureDate, setDepartureDate] = useState(
    moment(props?.reservation?.departure || formData?.reservation?.departure).format('YYYY-MM-DD')
  );
  const [propertyName, setPropertyName] = useState(null);
  const [alternateCID, setAlternateCID] = useState('');
  const [confirmationNumber, setConfirmationNumber] = useState(null);
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [startArrivalDate, setStartArrivalDate] = useState<any>(moment().format('YYYY-MM-DD'));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [startDepartureDate, setStartDepartureDate] = useState<any>(moment().format('YYYY-MM-DD'));
  const [skipQuery, setSkipQuery] = useState(false);
  const [petFeeData, setPetFeeData] = useState<PetFeeData>();
  const isPetPolicyResolved = skipQuery;
  const showPetSection = !isPetPolicyResolved ? false : petFeeData?.property?.policies?.petsAllowed !== false;
  // this data will come from AEM
  const mainHeading = props.model?.mainHeading;
  const additionalGuestsHeading = props.model?.additionalGuestsHeading;
  const additionalGuestsText = !guestDetailV2
    ? props.model?.additionalGuestsText
    : 'Would you like to add any guests or children to your reservation?';
  const guestInformationText = props.model?.guestInformationText;
  const travelingWithChildrenHeading = props.model?.travelingWithChildrenHeading;
  const travelingWithPetsHeading = props.model?.travelingWithPetsHeading;
  const needsHeading = props.model?.needsHeading;
  const needsText = props.model?.needsText;
  const contactPreferencesHeading = props.model?.contactPreferencesHeading;
  const contactPreferencesText = props.model?.contactPreferencesText;
  // const assistanceSectionText = props.model?.assistanceSectionText;
  const tripDetailsHeading = props.model?.tripDetailsHeading;
  const arrivalTimeText = props.model?.arrivalTimeText;
  const arrivalMethodText = props.model?.arrivalMethodText;
  const specialOccasionHeading = props.model?.specialOccasionHeading;
  const specialOccasionText = props.model?.specialOccasionText;
  const additionalRequestsHeading = props.model?.additionalRequestsHeading;
  const additionalRequestsText = props.model?.additionalRequestsText;
  const transportationHeading = props.model?.ransportationDetailsHeading || 'Transportation Details';
  const transportationDetailsText =
    props.model?.transportationDetailsText ||
    'Would you like us to assist with coordinating your travel arrangements for your arrival or departure?';
  const transportationSubHeading = props.model?.transportationDetailsSubText;
  const arrivalHeading = props.model?.arrivaldetailDetailsHeading || 'Arrival Details';
  const arrivalDetailsText = props?.model?.arrivalDetailsText;
  const departureText = props.model?.arrivalMethodText;
  const arrivalText = props.model?.arrivalTimeText;
  const subTitle18 = props.model?.departureMethodText || 'How else may we assist with transportation needs?';
  // const contentBottomLoadFlag = props?.model?.hasSummaryTestFlag || false;
  const summaryText = props?.model?.guestInformationText;
  //   const summaryText =
  //     '<p><span><b>%firstname% %lastname%,</b></span> here is your Travel Planner for Activities &amp; Experiences at <span><b>%hotelname%</b></span>. Please take a moment to share your preferences so we can craft a personalized experience for you.</p><p class="m-0">NOTE: Our Guest Relations team will follow up within 48 hours after you submit this form.</p>';

  const [replacedText, setReplacedText] = useState('');
  const [timeTitle, setTimeTitle] = useState('');
  const [travelingWithChildren, setTravelingWithChildren] = useState<string>('');
  const [travelingWithPets, setTravelingWithPets] = useState<string>('');
  const [accessibilityNeeds, setAccessibilityNeeds] = useState<string>('');
  const [accessibilityNeedsToggle, setAccessibilityNeedsToggle] = useState<string>('');
  const [specialOccasionRequest, setSpecialOccasionRequest] = useState<string>('');
  const [specialOccasionRequestOther, setSpecialOccasionRequestOther] = useState<string>('');
  const [surpriseRequest, setSurpriseRequest] = useState<string>('');
  const [needArrivalDepartureAssistance, setNeedArivalDepartureAssistance] = useState<string>('');
  const [specialOccasionToggle, setSpecialOccasionToggle] = useState<string>('');
  const [transportationMethodToggle, setTransportationMethodToggle] = useState<string>('');
  const [additionalRequestsToggle, setAdditionalRequestsToggle] = useState<string>(
    formData?.additional_requests_toggle ?? 'No'
  );
  const [additionalRequestsToggleShow, setAdditionalRequestsToggleShow] = useState<string>(
    formData?.additional_requests_toggle === 'Yes' ? 'hr-hidden' : 'hr-visible'
  );
  // const [arrivalMethod, setArrivalMethod] = useState<string>('');
  // const [transportationArrivalDate, setTransportationArrivalDate] = useState<string>('');
  // const [arrivalAnticipateTime, setArrivalAnticipateTime] = useState<string>('');
  // const [transportationDepart const [guestDetailV2, setoggleSection] = useState(false);ureDate, setTransportationDepartureDate] = useState<string>('');
  // const [departureMethod, setDepartureMethod] = useState<string>('');
  // const [transportationDepartureTime, setTransportationDepartureTime] = useState<string>('');
  const [isNavTrue, setIsNavTrue] = useState<boolean>(false);
  const isMobileViewPort = !useCheckBreakpoint('viewportL');
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const i18nText: any = props?.i18nMap;
  const labels = {
    title: mainHeading,
    subTitle1: `${
      props?.i18nMap?.signatureActivitiesExperiencesAt ?? 'Signature Activities & Experiences'
    } at <b> ${propertyName} </b>`,
    subTitle2: firstLastName,

    subTitle3: `<b> ${props?.i18nMap?.arrival ?? 'Arrival'}: </b>${arrivalDate}`,
    subTitle4: `<b> ${props?.i18nMap?.reservationNumber ?? 'Reservation'}: </b>${reservation}`,
    subTitle5: `<b> ${props?.i18nMap?.departure ?? 'Departure'}: </b>${departureDate}`,

    guestInformationText: guestInformationText,
    additionalGuestsHeading: additionalGuestsHeading,
    additionalGuestsText: additionalGuestsText,
    addpetText: 'Would you like to add any pets to your reservation?',
    travelingWithChildrenHeading: travelingWithChildrenHeading,
    travelingWithPetsHeading: travelingWithPetsHeading,
    needsHeading: needsHeading,
    needsText: needsText,
    contactPreferencesHeading: contactPreferencesHeading,
    contactPreferencesText: contactPreferencesText,
    tripDetailsHeading: tripDetailsHeading,
    // assistanceSectionText: assistanceSectionText,
    specialOccasionText: specialOccasionText,
    additionalRequestsText: additionalRequestsText,
    subTitle14: `${
      props?.i18nMap?.wouldYouLikeHelpCreatingMagicalMoment ??
      "Would you like our team's help creating a magical moment?"
    }`,
    subTitle15: `${props?.i18nMap?.isThisOccasionASurprise ?? 'Is this occasion a surprise'}?`,
    arrivalTimeText: arrivalTimeText,
    arrivalMethodText: arrivalMethodText,
    specialOccasionHeading: specialOccasionHeading,
    additionalRequestsHeading: additionalRequestsHeading,
    subTitle18: subTitle18,
    subTitle19: `${
      props?.i18nMap?.pleaseConfirmCoordinationOfSurprise ?? 'Please confirm how would you like to coordinate surprise.'
    }`,
    subTitle20: `${arrivalDetailsText}<span class="red-asterisk">*</span>`,
    subTitle21: `${
      props?.i18nMap?.contactBarrTransportation ??
      'For transportation please contact Barr/’s transportation at 904-642-1662.'
    }`,
    placeholder: `${props?.i18nMap?.usedForTextarea ?? 'This is used for textarea'}`,
    arrivalHeading: arrivalHeading,
    arrivalMethodErrorMessage: `${props?.i18nMap?.enterMethodOfArrival ?? 'Please enter method of arrival'}`,
    arrivalDateErrorMessage: `${props?.i18nMap?.enterArrivalDate ?? 'Please enter arrival date'}`,
    arrivalTimeErrorMessage: `${props?.i18nMap?.enterArrivalTime ?? 'Please enter arrival time'}`,
    departureMethodErrorMessage: `${props?.i18nMap?.enterMethodOfDeparture ?? 'Please enter method of departure'}`,
    departureDateErrorMessage: `${props?.i18nMap?.enterDepartureDate ?? 'Please enter departure date'}`,
    departureTimeErrorMessage: `${props?.i18nMap?.enterDepartureTime ?? 'Please enter departure time'}`,
    transportationHeading: transportationHeading,
    transportationSubHeading: transportationSubHeading,
    transportationDetailsText: transportationDetailsText,
    arrivalText: `${arrivalText}<span class="red-asterisk">*</span>`,
    departureText: `${departureText}<span class="red-asterisk">*</span>`,
    summaryText: replacedText,
    tripContacPhoneErrorMessage: `${props?.i18nMap?.tripContacPhoneErrorMessage ?? 'Please enter phone number'}`,
    tripContacWhatsAppErrorMessage: `${props?.i18nMap?.tripContacErrorMessage ?? 'Please enter WhatsApp number'}`,
    tripContacTextErrorMessage: `${props?.i18nMap?.tripContacErrorMessage ?? 'Please enter phone number'}`,
    tripContacWeChatErrorMessage: `${props?.i18nMap?.tripContacErrorMessage ?? 'Please enter WeChat number'}`,
    tripTimezoneErrorMessage: `${props?.i18nMap?.tripTimezoneErrorMessage ?? 'Please select time zone'}`,
  };

  const currentTimestamp = Date.now();
  const currentDateTimeStamp = new Date(currentTimestamp).getTime();

  useQuery(phoenixPrearrivalProperty, {
    variables: {
      propertyId: marshaCode,
      language: selectedLanguage,
    },
    context: {
      headers: {
        // Any header, including x-request-id, can be passed in args with query.
        // If you don't pass it in the authLink will generate a random ID.
        'accept-language': selectedLanguage,
        'x-request-id': props?.requestId,
        'x-b3-traceId': props?.requestId,
        'x-b3-spanId': props?.requestId,
        'correlation-id': `${
          props?.sessionData1?.sessionToken ?? props?.sessionData1?.cacheData?.key ?? 'fallback-token'
        } - ${currentDateTimeStamp}`,
        'graphql-operation-signature': `${
          props?.operationSignatures[0]?.signature ?? '427375df16a97ed62dfdf9b23c36bf4cdcb4d10514ff2dd6a820276d1712c9e6'
        }`,
      },
    },
    errorPolicy: 'all',
    onCompleted: data => {
      setPetFeeData(data);
      setSkipQuery(true);
    },
    onError: error => {
      console.error('Failed to get pet policy', error);
      setSkipQuery(true);
    },
    skip: skipQuery || !marshaCode,
  });

  useEffect(() => {
    if (formData.marshaCode) {
      setTotalPoint();
    }

    // Check if the key is present in sessionStorage
    const keyValue = sessionStorage.getItem('prearrivalSurveyFormState');

    if (confirmationNumber1) {
      if (!keyValue) {
        setFormData({
          ...formData,
          marshaCode: marshaCode,
          confirmationNumber: confirmationNumber1,
          amenities: props?.amenities,
          property_config: props?.property_config,
          reservation: props?.reservation,
          marsha_cd: marshaCode,
          reservation_num: props?.reservation?.confirmationNumber,
          preferred_contact_method_details: updatedDetails,
          passions: props?.passions,
          favIcon: props?.favIcon,
          brandCode: props?.brandCode,
        });
      }
    }
  }, [confirmationNumber1]);

  useEffect(() => {
    setTimeTitle('Hotel local time');
    if (
      (formData?.reservation?.customerFirstName && formData?.reservation?.customerLastName) ||
      (props?.reservation?.customerFirstName && props?.reservation?.customerLastName)
    ) {
      const firstName = capitalize(
        formData?.reservation?.customerFirstName
          ? formData?.reservation?.customerFirstName
          : props?.reservation?.customerFirstName
      );
      const lastName = capitalize(
        formData?.reservation?.customerLastName
          ? formData?.reservation?.customerLastName
          : props?.reservation?.customerLastName
      );
      setFirstLastName(`${firstName} ${lastName}`);
    }

    setArrivalDate(
      dayjs(formData?.reservation?.arrival ? formData?.reservation?.arrival : props?.reservation?.arrival).format(
        'MMM D, YYYY'
      )
    );
    setReservation(
      formData?.reservation?.confirmationNumber
        ? formData?.reservation?.confirmationNumber
        : props?.reservation?.confirmationNumber
    );
    setDepartureDate(
      dayjs(formData?.reservation?.departure ? formData?.reservation?.departure : props?.reservation?.departure).format(
        'MMM DD, YYYY'
      )
    );
    setPropertyName(
      formData?.property_config?.hotel_name ? formData?.property_config?.hotel_name : props?.property_config?.hotel_name
    );
    setAlternateCID(
      formData?.reservation?.AlternateCustomerId
        ? formData?.reservation?.AlternateCustomerId
        : props?.reservation?.AlternateCustomerId
    );
    setConfirmationNumber(
      formData?.reservation?.confirmationNumber
        ? formData?.reservation?.confirmationNumber
        : props?.reservation?.confirmationNumber
    );
    setCurrentDate(getResConfirmationDatePrefix(props?.reservation?.confoCreate || formData?.reservation?.confoCreate));
    setStartArrivalDate(
      formData?.transportation_arrival_date ? moment(formData?.transportation_arrival_date) : moment(arrivalDate)
    );
    setStartDepartureDate(
      formData.transportation_departure_date ? moment(formData.transportation_departure_date) : moment(arrivalDate)
    );
    setTravelingWithChildren(
      formData?.traveling_with_children ? formData?.traveling_with_children : props?.traveling_with_children
    );
    setTravelingWithPets(formData?.traveling_with_pets ? formData?.traveling_with_pets : props?.traveling_with_pets);
    setAccessibilityNeeds(formData?.accessiblity_needs ? formData?.accessiblity_needs : props?.accessiblity_needs);
    setAccessibilityNeedsToggle(
      formData?.accessibilityNeeds_toggle ? formData?.accessibilityNeeds_toggle : props?.accessibilityNeeds_toggle
    );
    setSpecialOccasionRequest(
      formData?.special_occasion_request ? formData?.special_occasion_request : props?.special_occasion_request
    );
    setSpecialOccasionRequestOther(
      formData?.special_occasion_request_other
        ? formData?.special_occasion_request_other
        : props?.special_occasion_request_other
    );
    setSurpriseRequest(formData?.surprise_request ? formData?.surprise_request : props?.surprise_request);
    setNeedArivalDepartureAssistance(
      formData?.need_arrival_departure_assistance
        ? formData?.need_arrival_departure_assistance
        : props?.need_arrival_departure_assistance
    );
    setSpecialOccasionToggle(
      formData?.specialOccasion_toggle ? formData?.specialOccasion_toggle : props?.specialOccasion_toggle
    );
    setTransportationMethodToggle(
      formData?.transportation_method_toggle
        ? formData?.transportation_method_toggle
        : props?.transportation_method_toggle
    );
    setAdditionalRequestsToggle(formData?.additional_requests_toggle ?? 'No');
    setAdditionalRequestsToggleShow(formData?.additional_requests_toggle === 'Yes' ? 'hr-hidden' : 'hr-visible');
    const replacements: Record<string, string> = {
      '%firstname%': formData?.reservation?.customerFirstName
        ? formData?.reservation?.customerFirstName
        : props?.reservation?.customerFirstName,
      '%lastname%': formData?.reservation?.customerLastName
        ? formData?.reservation?.customerLastName
        : props?.reservation?.customerLastName,
      '%resnumber%': formData?.reservation?.confirmationNumber
        ? formData?.reservation?.confirmationNumber
        : props?.reservation?.confirmationNumber,
      '%arrivaldate%': dayjs(
        formData?.reservation?.arrival ? formData?.reservation?.arrival : props?.reservation?.arrival
      ).format('MMM DD, YYYY'),
      '%departuredate%': dayjs(
        formData?.reservation?.departure ? formData?.reservation?.departure : props?.reservation?.departure
      ).format('MMM DD, YYYY'),
      '%hotelname%': formData?.property_config?.hotel_name
        ? formData?.property_config?.hotel_name
        : props?.property_config?.hotel_name,
    };

    setReplacedText(summaryText.replace(/%\w+%/g, (match: string) => replacements[match] ?? match));
  }, [formData, props]);

  useEffect(() => {
    // setArrivalMethod(formData?.arrival_method);
    // setTransportationArrivalDate(formData?.transportation_arrival_date);
    // setArrivalAnticipateTime(formData?.arrival_anticipate_time);
    // setTransportationDepartureDate(formData?.transportation_departure_date);
    // setDepartureMethod(formData?.departure_method);
    // setTransportationDepartureTime(formData?.transportation_departure_time);
  }, [formData?.arrival_method]);

  const combinedValue = `${currentDate}${confirmationNumber}`;

  type DivID =
    | 'div1'
    | 'div2'
    | 'div3'
    | 'div4'
    | 'div5'
    | 'div6'
    | 'div7'
    | 'div8'
    | 'div9'
    | 'div10'
    | 'div11'
    | 'div12'
    | 'div13'
    | 'div14'
    | 'div15'
    | 'div16'
    | 'div17'
    | 'div18'
    | 'div19'
    | 'div20'
    | 'div21'
    | 'div22'
    | 'div23'
    | 'div24'
    | 'div25'
    | 'div26'
    | 'div27';

  const [isVisible, setIsVisible] = useState<{ [key in DivID]: boolean }>({
    div1: false,
    div2: false,
    div3: false,
    div4: false,
    div5: false,
    div6: false,
    div7: false,
    div8: false,
    div9: false,
    div10: false,
    div11: false,
    div12: false,
    div13: false,
    div14: false,
    div15: false,
    div16: false,
    div17: false,
    div18: false,
    div19: false,
    div20: false,
    div21: false,
    div22: false,
    div23: false,
    div24: false,
    div25: false,
    div26: false,
    div27: false,
  });

  useEffect(() => {
    setIsVisible(prevState => ({
      ...prevState,
      div1: formData?.traveling_with_children === 'Yes',
      div2: travelingWithPets === 'Yes',
      div3: accessibilityNeeds === 'Yes',
      div5: specialOccasionRequest === 'Yes',
      div6: specialOccasionRequestOther === 'Yes',
      div7: surpriseRequest === 'Yes',
      div20: formData?.need_arrival_departure_assistance === 'Yes',
      div21: formData?.add_additional_guest === 'Yes',
      div22: accessibilityNeedsToggle === 'Yes',
      div23: specialOccasionToggle === 'Yes',
      div26: transportationMethodToggle === 'Yes',
      div27: additionalRequestsToggle === 'Yes',
    }));
  }, [
    travelingWithChildren,
    travelingWithPets,
    accessibilityNeeds,
    specialOccasionRequest,
    specialOccasionRequestOther,
    surpriseRequest,
    needArrivalDepartureAssistance,
    accessibilityNeedsToggle,
    formData,
    specialOccasionToggle,
    transportationMethodToggle,
    additionalRequestsToggle,
  ]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fetchMobileNumber = (obj: any) => {
    const updatedValue = obj.mobileNumber;
    const timeZone = obj.countryTimeZone;

    return { updatedValue, timeZone };
  };

  /**
   * Usestate function to update the form fields
   */

  // const { joinNowBtnClicked, setJoinNowBtnClicked } = useCreateSurveyStore();
  //const { errorsList, setErrorsList } = useCreateSurveyStore();

  useEffect(() => {
    setIsVisible(prevState => ({
      ...prevState,
      div18: !!formData.arrival_method || !!props.arrival_method,
      div19: !!formData.departure_method || !!props.departure_method,
      div2: formData.traveling_with_pets === 'Yes' || props.traveling_with_pets === 'Yes',
      div20: formData.need_arrival_departure_assistance === 'Yes' || props.need_arrival_departure_assistance === 'Yes',
    }));
  }, [
    formData.arrival_method,
    formData.departure_method,
    formData.traveling_with_pets,
    formData.need_arrival_departure_assistance,
    props.arrival_method,
    props.departure_method,
    props.traveling_with_pets,
    props.need_arrival_departure_assistance,
  ]);

  // need to check wheather will get the data from ACC or BED
  const errorMessageCorrectName = `${props?.i18nMap?.enterValidName ?? 'Please enter a valid name'}`;
  // const emailAddressWarning = 'Enter a valid email address';
  const firstNameError = '';
  const lastNameError = '';

  const [toastErrorMessage, setToastErrorMessage] = useState<string>('');
  const [isShowMessageToast, setIsShowMessageToast] = useState<boolean>(false);
  const [isShowErrorMessageToast, setIsShowErrorMessageToast] = useState<boolean>(false);
  const [validUserEmail] = useState<boolean>(true);
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
  const [checkedSpecialContactItems, setCheckedSpecialContactItems] = useState<{ [key: string]: boolean }>({});
  const [checkedSpecialItems, setSpecialCheckedItems] = useState<{ [key: string]: boolean }>({});
  const preferredCalendarRef = useRef<HTMLDivElement>(null); // Ref for preferred calendar container
  const alternateCalendarRef = useRef<HTMLDivElement>(null); // Ref for alternate calendar container

  // Effect to handle clicks outside the calendar containers
  useEffect(() => {
    // Function to handle clicks outside the calendar containers
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const isClickInsidePreferred = preferredCalendarRef.current?.contains(target);
      const isClickInsideAlternate = alternateCalendarRef.current?.contains(target);

      // If the click is outside both calendars, close them
      if (!isClickInsidePreferred && !isClickInsideAlternate) {
        setPreferredShowCalendar(false);
        setShowAlternateCalendar(false);
      }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [preferredCalendarRef, alternateCalendarRef]);

  const [selectedTimes, setSelectedTimes] = useState({
    deptteletime2: '',
    telephonetime2: '',
    localtime: '',
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const findContactDetail = (contacts: any, type: string) => {
    const contact = contacts?.find(
      (contact: { contact_method_type: string }) => contact.contact_method_type.toLowerCase() === type.toLowerCase()
    );
    return contact ? contact.contact_method_detail : null;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const findContactTimezone = (contacts: any, type: string) => {
    const contact = contacts?.find(
      (contact: { contact_method_type: string }) => contact.contact_method_type.toLowerCase() === type.toLowerCase()
    );
    return contact ? contact.timezone_of_guest : null;
  };

  const [customerEmail, setCustomerEmail] = useState(
    findContactDetail(formData?.preferred_contact_method_details, 'email') ?? props?.reservation?.cusotmerEmail
  );
  const [tripPhoneNumber, setTripPhoneNumber] = useState(
    findContactDetail(formData?.preferred_contact_method_details, 'phone') || ''
  );
  const [tripTextNumber, setTripTextNumber] = useState(
    findContactDetail(formData?.preferred_contact_method_details, 'text') || ''
  );
  const [tripWeChatNumber, setTripWeChatNumber] = useState(
    findContactDetail(formData?.preferred_contact_method_details, 'wechat') || ''
  );
  const [tripWhatsAppNumber, setTripWhatsAppNumber] = useState(
    findContactDetail(formData?.preferred_contact_method_details, 'whatsapp') || ''
  );
  const [tripPhoneNumberTimezone, setTripPhoneNumberTimezone] = useState(
    findContactTimezone(formData?.preferred_contact_method_details, 'phone') || 'Select'
  );
  const [tripTextNumberTimezone, setTripTextNumberTimezone] = useState(
    findContactTimezone(formData?.preferred_contact_method_details, 'text') || 'Select'
  );
  const [tripWeChatNumberTimezone, setTripWeChatNumberTimezone] = useState(
    findContactTimezone(formData?.preferred_contact_method_details, 'wechat') || 'Select'
  );
  const [tripWhatsAppNumberTimezone, setTripWhatsAppNumberTimezone] = useState(
    findContactTimezone(formData?.preferred_contact_method_details, 'whatsapp') || 'Select'
  );
  const [soTripCustomerEmail, setSoTripCustomerEmail] = useState(
    findContactDetail(formData?.surprise_request_coordination_contact_detail, 'email') ||
      props?.reservation?.cusotmerEmail
  );
  const [sotripPhoneNumber, setSotripPhoneNumber] = useState('');
  const [sotripTextNumber, setSotripTextNumber] = useState('');
  const [sotripWeChatNumber, setSotripWeChatNumber] = useState('');
  const [sotripWhatsAppNumber, setSotripWhatsAppNumber] = useState('');
  const [sotripPhoneNumberTimezone, setSotripPhoneNumberTimezone] = useState('');
  const [sotripTextNumberTimezone, setSotripTextNumberTimezone] = useState('');
  const [sotripWeChatNumberTimezone, setSotripWeChatNumberTimezone] = useState('');
  const [sotripWhatsAppNumberTimezone, setSotripWhatsAppNumberTimezone] = useState('');
  const [AccessOptionsArray, setAccessOptionsArray] = useState([]);
  const [showVariableErrorMessage, setShowVaribaleErrorMessage] = useState(false);
  useEffect(() => {
    setCustomerEmail(findContactDetail(formData?.preferred_contact_method_details, 'email'));
    setTripPhoneNumber(findContactDetail(formData?.preferred_contact_method_details, 'phone') || '');
    setTripTextNumber(findContactDetail(formData?.preferred_contact_method_details, 'text') || '');
    setTripWeChatNumber(findContactDetail(formData?.preferred_contact_method_details, 'wechat') || '');
    setTripWhatsAppNumber(findContactDetail(formData?.preferred_contact_method_details, 'whatsapp') || '');
    setTripPhoneNumberTimezone(findContactTimezone(formData?.preferred_contact_method_details, 'phone') || 'Select');
    setTripTextNumberTimezone(findContactTimezone(formData?.preferred_contact_method_details, 'text') || 'Select');
    setTripWeChatNumberTimezone(findContactTimezone(formData?.preferred_contact_method_details, 'wechat') || 'Select');
    setTripWhatsAppNumberTimezone(
      findContactTimezone(formData?.preferred_contact_method_details, 'whatsapp') || 'Select'
    );
    setSoTripCustomerEmail(
      findContactDetail(formData?.surprise_request_coordination_contact_detail, 'email') ||
        props?.reservation?.cusotmerEmail
    );
    setSotripPhoneNumber(findContactDetail(formData?.surprise_request_coordination_contact_detail, 'phone') || '');
    setSotripTextNumber(findContactDetail(formData?.surprise_request_coordination_contact_detail, 'text') || '');
    setSotripWeChatNumber(findContactDetail(formData?.surprise_request_coordination_contact_detail, 'wechat') || '');
    setSotripWhatsAppNumber(
      findContactDetail(formData?.surprise_request_coordination_contact_detail, 'whatsapp') || ''
    );
    setSotripPhoneNumberTimezone(
      findContactTimezone(formData?.surprise_request_coordination_contact_detail, 'phone') || 'Select'
    );
    setSotripTextNumberTimezone(
      findContactTimezone(formData?.surprise_request_coordination_contact_detail, 'text') || 'Select'
    );
    setSotripWeChatNumberTimezone(
      findContactTimezone(formData?.surprise_request_coordination_contact_detail, 'wechat') || 'Select'
    );
    setSotripWhatsAppNumberTimezone(
      findContactTimezone(formData?.surprise_request_coordination_contact_detail, 'whatsapp') || 'Select'
    );
    setAccessOptionsArray(formData?.property_config?.accessibility_options || []);
  }, [formData]);

  useEffect(() => {
    setShowVaribaleErrorMessage(formValidation);
    if (formValidation) {
      if (hasAlertMsg()) {
        setIsShowErrorMessageToast(true);
        setToastErrorMessage(`${props?.i18nMap?.alertMissingInfo ?? 'Alert: Please add missing information!'}`);
      } else {
        ValidateMandateData(true);
      }
      setTimeout(() => {
        setFormValidation(false);
        setShowVaribaleErrorMessage(false);
      }, 5000);
    }
  }, [formValidation]);
  const accessOptionsData: Array<{ label: string; name: string; enabled: string }> =
    AccessOptionsArray.length > 0 ? AccessOptionsArray : accessiblityDetailsCheckboxData;
  const toggleVisibility = (id: DivID) => {
    if (id !== 'div5' && id !== 'div6') {
      setIsVisible({
        ...isVisible,
        [id]: !isVisible[id], // Toggle visibility for the div with the given id
      });
    } else if (id === 'div5') {
      if (!isVisible['div5']) {
        setIsVisible({
          ...isVisible,
          [id]: !isVisible[id], // Toggle visibility for the div with the given id
        });
      } else {
        setIsVisible({
          ...isVisible,
          div5: false, // Toggle visibility for the div with the given id
          div6: false,
          div7: false,
        });
      }
    } else if (id === 'div6') {
      if (!isVisible['div6']) {
        setIsVisible({
          ...isVisible,
          [id]: !isVisible[id], // Toggle visibility for the div with the given id
        });
      } else {
        setIsVisible({
          ...isVisible,
          div6: false,
          div7: false,
        });
      }
    }
    if (id === 'div1') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        // setChildrenDataList([]);
        setFormData({
          ...formData,
          children_details: [],
          traveling_with_children: 'No',
        });
      } else {
        setFormData({
          ...formData,
          traveling_with_children: 'Yes',
        });
      }
    }
    if (id === 'div3') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setCheckedItems({});
        setFormData({
          ...formData,
          accessiblity_needs: 'No',
          accessiblity_details: [],
          accessibility_notes: '',
        });
      } else {
        setFormData({
          ...formData,
          accessiblity_needs: 'Yes',
        });
      }
    }
    if (id === 'div22') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setCheckedItems({});
        setFormData({
          ...formData,
          accessibilityNeeds_toggle: 'No',
          accessiblity_needs: 'No',
          accessiblity_details: [],
          accessibility_notes: '',
        });
      } else {
        setFormData({
          ...formData,
          accessibilityNeeds_toggle: 'Yes',
          accessiblity_needs: 'Yes',
        });
      }
    }

    if (id === 'div2') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setFormData({
          ...formData,
          pet_details: [],
          traveling_with_pets: 'No',
        });
      } else {
        setFormData({
          ...formData,
          traveling_with_pets: 'Yes',
        });
      }
    }
    if (id === 'div21') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setFormData({
          ...formData,
          additional_guests_details: [],
          children_details: [],
          add_additional_guest: 'No',
        });
      } else {
        setFormData({
          ...formData,
          add_additional_guest: 'Yes',
        });
      }
    }
    if (id === 'div20') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setTelephoneTime('');
        setDeptteleTime('');
        setHasError({
          ...hasError,
          arrivalMethodError: '',
          departureMethodError: '',
          arrivalDateError: '',
          departureDateError: '',
          arrivalTime: '',
          departureTime: '',
        });
        setSelectedTimes({ ...selectedTimes, deptteletime2: '', telephonetime2: '' });
        setFormData({
          ...formData,
          arrival_method: '',
          departure_method: '',
          transportation_arrival_date: '',
          transportation_arrival_time: '',
          transportation_departure_date: '',
          transportation_departure_time: '',
          arrival_dept_notes: '',
          need_arrival_departure_assistance: 'No',
          arrivalInfo: '',
          arrivalFlightNumber: '',
          arrivalPassengers: '',
          departureInfo: '',
          departureFlightNumber: '',
          departurePassengers: '',
        });
      } else {
        setFormData({
          ...formData,
          need_arrival_departure_assistance: 'Yes',
          isNavError: false,
        });
      }
    }
    if (id === 'div26') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setTelephoneTime('');
        setDeptteleTime('');
        setHasError({
          ...hasError,
          arrivalMethodError: '',
          departureMethodError: '',
          arrivalDateError: '',
          departureDateError: '',
          arrivalTime: '',
          departureTime: '',
        });
        setSelectedTimes({ ...selectedTimes, deptteletime2: '', telephonetime2: '' });
        setFormData({
          ...formData,
          transportation_method_toggle: 'No',
          arrival_method: '',
          departure_method: '',
          transportation_arrival_date: '',
          transportation_arrival_time: '',
          transportation_departure_date: '',
          transportation_departure_time: '',
          arrival_dept_notes: '',
          need_arrival_departure_assistance: 'No',
        });
      } else {
        setFormData({
          ...formData,
          transportation_method_toggle: 'Yes',
          need_arrival_departure_assistance: 'Yes',
          isNavError: false,
        });
      }
    }
    if (id === 'div23') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setCheckedSpecialContactItems({});
        setSpecialCheckedItems({});
        setFormData({
          ...formData,
          specialOccasion_toggle: 'No',
          special_occasion_request_category_details: [],
          special_occasion_request: 'No',
          special_occasion_request_other_notes: '',
          surprise_request_coordination_contact_detail: [],
          tip_checked_details: [],
          special_occasion_request_notes: '',
          special_occasion_request_other: 'No',
          surprise_request: 'No',
        });
      } else {
        setFormData({
          ...formData,
          specialOccasion_toggle: 'Yes',
          special_occasion_request: 'Yes',
        });
      }
    }
    if (id === 'div25') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setFormData({
          ...formData,
          arrival_anticipate_time: '',
          arrival_method_innertoggle: 'No',
        });
      } else {
        setFormData({
          ...formData,
          arrival_method_innertoggle: 'Yes',
        });
      }
    }
    if (id === 'div27') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setAdditionalRequestsToggleShow('hr-visible');
        setFormData({
          ...formData,
          additional_requests_toggle: 'No',
          additional_requests: '',
        });
      } else {
        setAdditionalRequestsToggleShow('hr-hidden');
        setFormData({
          ...formData,
          additional_requests_toggle: 'Yes',
        });
      }
    }
    if (id === 'div5') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setCheckedSpecialContactItems({});
        setSpecialCheckedItems({});
        setFormData({
          ...formData,
          special_occasion_request_category_details: [],
          special_occasion_request: 'No',
          special_occasion_request_other_notes: '',
          surprise_request_coordination_contact_detail: [],
          tip_checked_details: [],
          special_occasion_request_notes: '',
          special_occasion_request_other: 'No',
          surprise_request: 'No',
        });
      } else {
        setFormData({
          ...formData,
          special_occasion_request: 'Yes',
        });
      }
    }
    if (id === 'div6') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setCheckedSpecialContactItems({});
        setFormData({
          ...formData,
          special_occasion_request_notes: '',
          special_occasion_request_other: 'No',
          tip_checked_details: [],
          surprise_request_coordination_contact_detail: [],
          surprise_request: 'No',
        });
      } else {
        setFormData({
          ...formData,
          special_occasion_request_other: 'Yes',
        });
      }
    }
    if (id === 'div7') {
      const newVisibility = !isVisible[id];
      if (!newVisibility) {
        setCheckedSpecialContactItems({});
        setFormData({
          ...formData,
          tip_checked_details: [],
          surprise_request_coordination_contact_detail: [],
          surprise_request: 'No',
        });
      } else {
        setFormData({
          ...formData,
          surprise_request: 'Yes',
        });
      }
    }
  };

  const handleTimeChange = (newTime: string, type: 'deptteletime2' | 'telephonetime2' | 'localtime') => {
    // Update the selected times state
    const updatedTimes = { ...selectedTimes, [type]: newTime };
    setSelectedTimes(updatedTimes);

    // Update the form data state
    switch (type) {
      case 'deptteletime2':
        setHasError({ ...hasError, departureTime: '' });
        setFormData({ ...formData, transportation_departure_time: newTime });
        break;
      case 'telephonetime2':
        setHasError({ ...hasError, arrivalTime: '' });
        setFormData({ ...formData, transportation_arrival_time: newTime });
        break;
      case 'localtime':
        setHasError({ ...hasError, arrivalAnticipateError: '' });
        setFormData({ ...formData, arrival_anticipate_time: newTime });
        break;
      default:
        break;
    }
  };

  // Handle checkbox change
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAccessCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked, value } = e.target;
    setCheckedItems(prevState => ({
      ...prevState,
      [name]: checked,
    }));

    checked
      ? setFormData({ ...formData, accessiblity_details: [...formData.accessiblity_details, value] })
      : setFormData({
          ...formData,
          accessiblity_details: formData.accessiblity_details.filter((str: string) => str !== value),
        });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSpecialCategoryCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked, value } = e.target;
    setSpecialCheckedItems(prevState => ({
      ...prevState,
      [name]: checked,
    }));

    checked
      ? setFormData({
          ...formData,
          special_occasion_request_category_details: [...formData.special_occasion_request_category_details, value],
        })
      : setFormData({
          ...formData,
          special_occasion_request_category_details: formData.special_occasion_request_category_details.filter(
            (str: string) => str !== value
          ),
        });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updatePreferredContactMethodDetails = (type: any, detail: any, timezone: any) => {
    const updatedDetails = formData.preferred_contact_method_details.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (item: any) => item.contact_method_type !== type
    );

    if (detail || timezone) {
      updatedDetails.push({
        contact_method_type: type,
        contact_method_detail: detail,
        timezone_of_guest: timezone, // Add logic to set the correct timezone if needed
      });
    }

    setFormData({ preferred_contact_method_details: updatedDetails });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updatePreferredSoContactMethodDetails = (type: any, detail: any, timezone: any) => {
    const updatedDetails = formData.surprise_request_coordination_contact_detail.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (item: any) => item.contact_method_type !== type
    );

    if (detail) {
      updatedDetails.push({
        contact_method_type: type,
        contact_method_detail: detail,
        timezone_of_guest: timezone, // Add logic to set the correct timezone if needed
      });
    }

    setFormData({ surprise_request_coordination_contact_detail: updatedDetails });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCheckboxChange = (type: any, checked: any) => {
    if (type === 'email') {
      setFormData({ ...formData, tripEmailCheckbox: checked });
      updatePreferredContactMethodDetails(
        'email',
        `${formData?.reservation?.cusotmerEmail || props?.reservation?.cusotmerEmail}`,
        ''
      );
      setTripEmailCheckbox(checked);
    } else if (type === 'phone') {
      setFormData({ ...formData, tripPhoneCheckbox: checked });
      setTripPhoneCheckbox(checked);

      if (!checked) {
        setHasError({ ...hasError, tripPhoneNumberError: '', tripPhoneNumberTimezoneError: '' });
        updatePreferredContactMethodDetails('phone', '', '');
      }
    } else if (type === 'text') {
      setFormData({ ...formData, tripTextCheckbox: checked });
      setTripTextCheckbox(checked);

      if (!checked) {
        setHasError({ ...hasError, tripTextNumberError: '', tripTextNumberTimezoneError: '' });
        updatePreferredContactMethodDetails('text', '', '');
      }
    } else if (type === 'wechat') {
      setFormData({ ...formData, tripWechatCheckbox: checked });
      setTripWechatCheckbox(checked);

      if (!checked) {
        setHasError({ ...hasError, tripWeChatNumberError: '', tripWeChatNumberTimezoneError: '' });
        updatePreferredContactMethodDetails('wechat', '', '');
      }
    } else if (type === 'whatsapp') {
      setFormData({ ...formData, tripWhatsappCheckbox: checked });
      setTripWhatsappCheckbox(checked);

      if (!checked) {
        setHasError({ ...hasError, tripWhatsAppNumberError: '', tripWhatsAppNumberTimezoneError: '' });
        updatePreferredContactMethodDetails('whatsapp', '', '');
      }
    }

    if (!checked) updatePreferredContactMethodDetails(type, '', '');
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSoCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked, id } = e.target;
    setCheckedSpecialContactItems(prevState => ({
      ...prevState,
      [name]: checked,
    }));
    checked
      ? setFormData({ ...formData, tip_checked_details: [...formData.tip_checked_details, name] })
      : setFormData({
          ...formData,
          tip_checked_details: formData.tip_checked_details.filter((str: string) => str !== name),
        });
    if (name === 'soEmailCheckbox') {
      updatePreferredSoContactMethodDetails(
        'email',
        `${formData?.reservation?.cusotmerEmail || props?.reservation?.cusotmerEmail}`,
        ''
      );
    }
    if (!checked) updatePreferredSoContactMethodDetails(id, '', '');
  };

  const errorMessage1 = 'Please limit your input to 255 characters.';
  /**
   * reset the form data
   */
  const [errors, setErrors] = useState<FormError>({
    tripEmailError: '',
    errorTripEmail: '',
    errorSoTripEmail: '',
  });

  const [customError, setCustomError] = useState({
    errorTripEmail: '',
    errorSoTripEmail: '',
  });

  const [telephonetime, setTelephoneTime] = useState('');
  const [hasError, setHasError] = useState({
    arrivalAnticipateError: '',
    arrivalMethodError: '',
    departureMethodError: '',
    arrivalDateError: '',
    departureDateError: '',
    arrivalTime: '',
    departureTime: '',
    tripPhoneNumberError: '',
    tripPhoneNumberTimezoneError: '',
    tripTextNumberError: '',
    tripTextNumberTimezoneError: '',
    tripWeChatNumberError: '',
    tripWeChatNumberTimezoneError: '',
    tripWhatsAppNumberError: '',
    tripWhatsAppNumberTimezoneError: '',
    errorTripEmail: '',
  }); //Sahana12
  const [deptteletime, setDeptteleTime] = useState('');

  const [tripEmail, setTripEmail] = useState('');

  const [showPreferredCalendar, setPreferredShowCalendar] = useState(false);
  const [showAlternateCalendar, setShowAlternateCalendar] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDateChange = (date: any) => {
    setTelephoneTime(moment(date).format('YYYY-MM-DD'));
    setFormData({
      ...formData,
      transportation_arrival_date: moment(date).format('YYYY-MM-DD'),
    });
    setPreferredShowCalendar(false); // Hide calendar after date selection
    setHasError({ ...hasError, arrivalDateError: '' });
  };
  const handleInputClick = (type: string) => {
    if (type === 'preferred') {
      setPreferredShowCalendar(true);
      setShowAlternateCalendar(false);
    } else {
      setShowAlternateCalendar(true);
      setPreferredShowCalendar(false);
    }
  };
  const disabledDays = [
    // Dates before arrival date
    ...getDatesInRange(new Date(0), moment(arrivalDate)),
    // Dates after departure date
    ...getDatesInRange(departureDate, new Date(9999999999999)),
  ];
  // Helper function to generate dates in a range
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function getDatesInRange(start: any, end: any): Date[] {
    const dates = [];
    const currentDate = new Date(start);
    if (currentDate < end) {
      currentDate.setDate(currentDate.getDate() + 1);
    }
    while (currentDate < end) {
      dates.push(new Date(currentDate)); // Add a copy of the current date
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }

    return dates;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAlternateDateChange = (date: any) => {
    setDeptteleTime(moment(date).format('YYYY-MM-DD'));
    setFormData({
      ...formData,
      transportation_departure_date: moment(date).format('YYYY-MM-DD'),
    });
    setShowAlternateCalendar(false); // Hide calendar after date selection
    setHasError({ ...hasError, departureDateError: '' });
  };

  const validateAllFields = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newErrors: any = {};
    let isValid = true;
    if (!formData?.additional_guests_details?.guest_first_name) {
      newErrors.firstNameError = firstNameError;
      isValid = false;
    }

    if (formData?.additional_guests_details?.guest_first_name) {
      if (!ALPHABETS_REGEX.test(formData?.additional_guests_details?.guest_first_name)) {
        newErrors.errorFirstName = errorMessageCorrectName;
        isValid = false;
      }
    }

    if (!formData?.additional_guests_details?.guest_last_name) {
      newErrors.lastNameError = lastNameError;
      isValid = false;
    }

    if (formData?.additional_guests_details?.guest_last_name) {
      if (!ALPHABETS_REGEX.test(formData?.additional_guests_details?.guest_last_name)) {
        newErrors.errorLastName = errorMessageCorrectName;
        isValid = false;
      }
    }

    setErrors(newErrors);
    //setErrorsList(Object.values(newErrors));
    //setFormValidation(isValid);
    return isValid;
  };

  //validate the madate fields
  const ValidateMandateData = (isLoad: boolean) => {
    const validations = [
      {
        condition: !selectedTimes.localtime && !formData?.arrival_anticipate_time,
        errorKey: 'arrivalAnticipateError',
      },
    ];
    // Check preferred contact method inputs only if corresponding checkboxes are checked
    if (tripPhoneCheckbox && !tripPhoneNumber) {
      validations.push({ condition: true, errorKey: 'tripPhoneNumberError' });
    }
    if (tripPhoneCheckbox && tripPhoneNumberTimezone === 'Select') {
      validations.push({ condition: true, errorKey: 'tripPhoneNumberTimezoneError' });
    }

    if (tripTextCheckbox && !tripTextNumber) {
      validations.push({ condition: true, errorKey: 'tripTextNumberError' });
    }
    if (tripTextCheckbox && tripTextNumberTimezone === 'Select') {
      validations.push({ condition: true, errorKey: 'tripTextNumberTimezoneError' });
    }

    if (tripWechatCheckbox && !tripWeChatNumber) {
      validations.push({ condition: true, errorKey: 'tripWeChatNumberError' });
    }
    if (tripWechatCheckbox && tripWeChatNumberTimezone === 'Select') {
      validations.push({ condition: true, errorKey: 'tripWeChatNumberTimezoneError' });
    }

    if (tripWhatsappCheckbox && !tripWhatsAppNumber) {
      validations.push({ condition: true, errorKey: 'tripWhatsAppNumberError' });
    }
    if (tripWhatsappCheckbox && tripWhatsAppNumberTimezone === 'Select') {
      validations.push({ condition: true, errorKey: 'tripWhatsAppNumberTimezoneError' });
    }
    // Include arrival and departure method validations only if div20 is visible
    if (isVisible.div20) {
      validations.push(
        {
          condition: !formData?.arrival_method,
          errorKey: 'arrivalMethodError',
        },
        {
          condition: !formData?.departure_method,
          errorKey: 'departureMethodError',
        },
        {
          condition: !telephonetime && !formData.transportation_arrival_date,
          errorKey: 'arrivalDateError',
        },
        {
          condition: !deptteletime && !formData.transportation_departure_date,
          errorKey: 'departureDateError',
        },
        {
          condition: !selectedTimes.telephonetime2 && !formData.transportation_arrival_time,
          errorKey: 'arrivalTime',
        },
        {
          condition: !selectedTimes.deptteletime2 && !formData.transportation_departure_time,
          errorKey: 'departureTime',
        }
      );
    }

    let showTransportationToast = false;
    let hasAnyErrors = false;

    validations.forEach(({ condition, errorKey }) => {
      if (condition) {
        setHasError(prev => ({ ...prev, [errorKey]: 'error' }));
        hasAnyErrors = true;
        if (errorKey.includes('arrival') || errorKey.includes('departure')) {
          showTransportationToast = true;
        }
        setShowVaribaleErrorMessage(true);
        setIsShowErrorMessageToast(true);
        setToastErrorMessage(`${props?.i18nMap?.alertMissingInfo ?? 'Alert: Please add missing information!'}`);

        setFormValidation(true);
      } else {
        setHasError(prev => ({ ...prev, [errorKey]: '' }));
        setFormValidation(false);
      }
    });
    setFormValidation(hasAnyErrors);
    if (!hasAlertMsg()) {
      if (!isLoad) {
        if (!hasAnyErrors && validateForm()) {
          handleNextPage('dining.mi');

          //router.push("/next-page"); // Replace with your desired route
        } else {
          //alert("Please fix form errors before continuing.");
          setFormValidation(true);
        }
      }
    } else {
      setFormValidation(true);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setIsShowMessageToast(false);
      setIsShowErrorMessageToast(false);
    }, 5000);
  }, [isShowErrorMessageToast]);

  const handleAddFormData = () => {
    // Do something with the form element data-testid
    if (hasAlertMsg()) {
      setFormValidation(true);
      setIsShowErrorMessageToast(true);
      setToastErrorMessage(`${props?.i18nMap?.alertMissingInfo ?? 'Alert: Please add missing information!'}`);
    } else {
      setTotalPoint();
      validateAllFields();
    }
    setTimeout(() => {
      setIsShowMessageToast(false);
      setIsShowErrorMessageToast(false);
    }, 5000);
  };

  // Define the filtering function
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const filterContactData = (contactData: any, formData: any, props: any) => {
    // Extract contact preferences from formData
    const { phone_contact, text_contact, email_contact, wechat_contact, whatsapp_contact } =
      formData.property_config || {};

    const {
      phone_contact: phoneContactProps,
      text_contact: textContactProps,
      email_contact: emailContactProps,
      wechat_contact: wechatContactProps,
      whatsapp_contact: whatsappContactProps,
    } = props.property_config || {};

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    // Filter the contactData based on the contact preferences
    return contactData.filter(({ type }: any) => {
      // Determine if the current type should be included based on the formData and props
      const isPhoneContactValid =
        (phone_contact && phone_contact !== '0') || (phoneContactProps && phoneContactProps !== '0');
      const isTextContactValid =
        (text_contact && text_contact !== '0') || (textContactProps && textContactProps !== '0');
      const isEmailContactValid =
        (email_contact && email_contact !== '0') || (emailContactProps && emailContactProps !== '0');
      const isWeChatContactValid =
        (wechat_contact && wechat_contact !== '0') || (wechatContactProps && wechatContactProps !== '0');
      const isWhatsAppContactValid =
        (whatsapp_contact && whatsapp_contact !== '0') || (whatsappContactProps && whatsappContactProps !== '0');

      if (type === 'phone' && isPhoneContactValid) return true;
      if (type === 'text' && isTextContactValid) return true;
      if (type === 'email' && isEmailContactValid) return true;
      if (type === 'wechat' && isWeChatContactValid) return true;
      if (type === 'whatsapp' && isWhatsAppContactValid) return true;

      return false;
    });
  };
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasteData = e.clipboardData.getData('text');
    const cleanData = removeXSSScripts(pasteData);

    if (!cleanData) {
      // Block paste completely if dangerous content
    } else {
      // Optionally, update the state immediately with cleaned value
      // setLocalFormDataList(prev => ({
      //   ...prev,
      //   [field]: cleanData,
      // }));
    }
  };

  const renderFormAddGuest = () => {
    return (
      <form method="post" data-testid="create-guest-detail-form" className="guest-form">
        <div className="addGuestButton">
          <Button
            className="m-button-m m-button-secondary custom-btn mx-0 guestButton "
            type={Types.ButtonTypeVariation.Button}
            buttonCopy={props?.i18nMap?.addGuest ?? 'Add Guest'}
            callback={() => sectionRef.current?.addSection('guest')}
            id="addGuest"
          ></Button>
        </div>
      </form>
    );
  };

  /**
   * Render the children Form
   */
  const renderFormAddChildren = () => {
    return (
      <form method="post" data-testid="create-children-form" className="children-form">
        <div className=" col-12 col-xl-10 px-0">
          <div className="d-flex justify-content-between align-items-center flex-row guestButton-wrapper ">
            <Button
              className="m-button-m m-button-secondary custom-btn mx-0 complete-btn guestButton childButton"
              type={Types.ButtonTypeVariation.Button}
              buttonCopy={props?.i18nMap?.addChildren ?? 'Add Children'}
              callback={() => sectionRef.current?.addSection('child')}
              id="addChildren"
            ></Button>
          </div>
        </div>
      </form>
    );
  };

  /**
   * Render the pet detail Form
   */
  const renderFormPetDetail = () => {
    return (
      <form method="post" data-testid="create-pet-detail-form" className="pet-form mb-2">
        <div className=" col-12 col-xl-10 px-0">
          <div className="d-flex justify-content-between align-items-center guestButton-wrapper flex-row">
            <Button
              className="m-button-m m-button-secondary custom-btn mx-0 guestButton"
              type={Types.ButtonTypeVariation.Button}
              buttonCopy="Add Pet"
              callback={() => sectionPetRef.current?.addSection('pet')}
              id="addPet"
            ></Button>
          </div>
        </div>
      </form>
    );
  };
  /**
   * Special Occasion Details
   */
  const renderFormSpecialOccasion = () => {
    const filteredSpecialContactData = filterContactData(specialCheckboxData, formData, props);
    // Use the first 3 items from specialCheckboxData if filteredSpecialContactData is empty or null
    const contactDataToUse =
      filteredSpecialContactData && filteredSpecialContactData.length > 0
        ? filteredSpecialContactData
        : specialCheckboxData.slice(0, 3);
    return (
      <form method="post" data-testid="trip-special-ocation-details">
        {!guestDetailV2 && (
          <div
            className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
              specialOccasionRequest === 'Yes' && 'mb-2'
            }`}
          >
            <p>
              <span className="sr-only">Are you celebrating a special occasion? If so, please tell us more.</span>
            </p>
          </div>
        )}
        {(specialOccasionRequest === 'Yes' || (guestDetailV2 && formData.specialOccasion_toggle === 'Yes')) && (
          <div className=" col-12 col-xl-10 px-0 isActive">
            <div className="d-flex justify-content-between align-items-center flex-row">
              <div className="row mt-5 spcial-occasion-checkboxes">
                {specialOcationCheckboxData.map((checkbox, index) => (
                  <div key={`checkbox-${index}-${checkbox.name}`} className="col-md-6">
                    <CheckBox
                      checkboxName={checkbox.name}
                      checkboxLabel={checkbox.label}
                      checked={
                        checkedSpecialItems[checkbox.name] ||
                        (formData &&
                          formData.special_occasion_request_category_details &&
                          formData.special_occasion_request_category_details.includes(checkbox.label))
                      }
                      onChange={handleSpecialCategoryCheckboxChange}
                      checkboxId={`specialcheckbox-${index}`}
                      data-testid={`specialcheckbox-${checkbox.name}`}
                      key={`specialcheckbox-${index}-${checkbox.name}`}
                      value={`${checkbox.label}`}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6 mt-2 p-0">
              <TextArea
                id={`${inputId}-soGuestNotesArea`}
                key="soGuestNotesArea"
                name="soGuestNotesArea"
                label="soGuestNotesArea"
                placeHolderText={props?.i18nMap?.pleaseAddNotes ?? 'Please add notes here'}
                getInputValue={(val: string) => {
                  setFormData({ ...formData, special_occasion_request_other_notes: removeXSSScripts(val) });
                }}
                inputValue={removeXSSScripts(formData.special_occasion_request_other_notes)}
                maxLength={255}
                messageError={errorMessage1}
              ></TextArea>
            </div>
            <Text
              element={Types.tags.paragraph}
              fontSize={Types.size.medium}
              dangerouslySetInnerHTML={{ __html: labels.subTitle14 }}
              customClass="mb-2 mt-3 subTitle"
            ></Text>
            <div
              className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                specialOccasionRequestOther === 'Yes' && 'mb-2'
              }`}
            >
              <span className="toggle-text-no">No </span>
              <Switch
                toggleId="toggleswitch6"
                toggleName="toggle2"
                onChange={() => toggleVisibility('div6')}
                selected={formData.special_occasion_request_other === 'Yes'}
              >
                <span className="sr-only">Would you like our team's help creating a magical moment?</span>
              </Switch>
              <span className="toggle-text"> Yes</span>
            </div>
            {specialOccasionRequestOther === 'Yes' && (
              <div className=" isActive">
                <div className="col-md-6 mt-1 p-0">
                  <TextArea
                    id={`${inputId}-soMagicalMomentNotesArea`}
                    key="soMagicalMomentNotesArea"
                    name="soMagicalMomentNotesArea"
                    label="soMagicalMomentNotesArea"
                    placeHolderText="Please add notes here"
                    getInputValue={(val: string) => {
                      setFormData({ ...formData, special_occasion_request_notes: val });
                    }}
                    inputValue={removeXSSScripts(formData?.special_occasion_request_notes)}
                    maxLength={255}
                    messageError={errorMessage1}
                  ></TextArea>
                </div>
                <Text
                  element={Types.tags.paragraph}
                  fontSize={Types.size.medium}
                  dangerouslySetInnerHTML={{ __html: labels.subTitle15 }}
                  customClass="mb-2 mt-3 subTitle"
                ></Text>
                <div
                  className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                    surpriseRequest === 'Yes' && 'mb-2'
                  }`}
                >
                  <span className="toggle-text-no">No </span>
                  <Switch
                    toggleId="toggleswitch7"
                    toggleName="toggle"
                    onChange={() => toggleVisibility('div7')}
                    selected={formData.surprise_request === 'Yes'}
                  >
                    <span className="sr-only">Is this occasion a surprise?</span>
                  </Switch>
                  <span className="toggle-text"> Yes</span>
                </div>
                {surpriseRequest === 'Yes' && (
                  <div>
                    <Text
                      element={Types.tags.paragraph}
                      fontSize={Types.size.medium}
                      dangerouslySetInnerHTML={{ __html: fragmentString1 }}
                      customClass="mb-3 mt-1 subTitle"
                    ></Text>
                    <div className="col-md-9 p-0 trip-contact-details">
                      {contactDataToUse.map(
                        (
                          /* eslint-disable  @typescript-eslint/no-explicit-any */
                          { name, label, field, type }: any
                        ) => (
                          <div key={name} className="trip-contact-check">
                            <CheckBox
                              checkboxName={name}
                              onChange={handleSoCheckboxChange}
                              checked={formData.tip_checked_details.includes(name)}
                              checkboxLabel={label}
                              checkboxId={`${type}`}
                              data-testid={`checkbox-${name}`}
                            />
                            {type === 'email' &&
                              (checkedSpecialContactItems[name] || formData.tip_checked_details.includes(name)) && (
                                <InputTextField
                                  label={field}
                                  placeHolderText={customerEmail}
                                  inputValue={removeXSSScripts(soTripCustomerEmail)}
                                  showErrorMessage={
                                    !validUserEmail || !!errors.errorSoTripEmail || !!customError.errorSoTripEmail
                                  }
                                  messageToShow={customError?.errorSoTripEmail ? customError?.errorSoTripEmail : ''}
                                  setErrorHtml={true}
                                  inputMaxLength={255}
                                  messageClass="error-label"
                                  getInputProps={() => ({
                                    autoComplete: 'off',
                                    id: `${field}`,
                                    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
                                  })}
                                  getLabelProps={() => ({
                                    htmlFor: `${field}`,
                                  })}
                                  className={clsx(
                                    'm-input-field m-checkbox mt-2 mb-3',
                                    !validUserEmail || !!errors?.errorSoTripEmail || !!customError.errorSoTripEmail
                                      ? 'is-error'
                                      : tripEmail
                                      ? 'is-active'
                                      : ''
                                  )}
                                  getInputValue={val => {
                                    setTripEmail(val);
                                    updatePreferredSoContactMethodDetails(type, removeXSSScripts(val), '');

                                    if (val.length >= 255) {
                                      setCustomError({ ...customError, errorSoTripEmail: errorMessage1 });
                                    } else {
                                      setCustomError({ ...customError, errorSoTripEmail: '' });
                                    }
                                  }}
                                  onBlur={(val: any) => {
                                    const newValue = val.target.value;
                                    if (newValue.length >= 255) {
                                      setCustomError({ ...customError, errorSoTripEmail: errorMessage1 });
                                    } else {
                                      setCustomError({ ...customError, errorSoTripEmail: '' });
                                    }
                                  }}
                                  infoLabel={field}
                                />
                              )}
                            {type === 'phone' &&
                              (checkedSpecialContactItems[name] || formData.tip_checked_details.includes(name)) && (
                                <PhoneNumberField
                                  label={field}
                                  inputValue={removeXSSScripts(sotripPhoneNumber)}
                                  mobileInputVal={sotripPhoneNumber}
                                  disabled={false}
                                  inputErrorMsg={''}
                                  isNonChinaMobileEnabled={true}
                                  dropdownTimeZoneOptions={countriesDialTimeZone}
                                  defaultTimeZoneOption={sotripPhoneNumberTimezone}
                                  fetchMobileNumber={(obj: any) => {
                                    const { updatedValue, timeZone } = fetchMobileNumber(obj);
                                    updatePreferredSoContactMethodDetails(
                                      type,
                                      removeXSSScripts(updatedValue),
                                      timeZone
                                    );
                                  }}
                                />
                              )}
                            {type === 'text' &&
                              (checkedSpecialContactItems[name] || formData.tip_checked_details.includes(name)) && (
                                <PhoneNumberField
                                  label={field}
                                  inputValue={removeXSSScripts(sotripTextNumber)}
                                  mobileInputVal={sotripTextNumber}
                                  disabled={false}
                                  inputErrorMsg=""
                                  isNonChinaMobileEnabled={true}
                                  dropdownTimeZoneOptions={countriesDialTimeZone}
                                  defaultTimeZoneOption={sotripTextNumberTimezone}
                                  fetchMobileNumber={(obj: any) => {
                                    const { updatedValue, timeZone } = fetchMobileNumber(obj);
                                    updatePreferredSoContactMethodDetails(
                                      type,
                                      removeXSSScripts(updatedValue),
                                      timeZone
                                    );
                                  }}
                                />
                              )}
                            {type === 'wechat' &&
                              (checkedSpecialContactItems[name] || formData.tip_checked_details.includes(name)) && (
                                <PhoneNumberField
                                  label={field}
                                  inputValue={removeXSSScripts(sotripWeChatNumber)}
                                  mobileInputVal={sotripWeChatNumber}
                                  disabled={false}
                                  inputErrorMsg=""
                                  isNonChinaMobileEnabled={true}
                                  dropdownTimeZoneOptions={countriesDialTimeZone}
                                  defaultTimeZoneOption={sotripWeChatNumberTimezone}
                                  fetchMobileNumber={(obj: any) => {
                                    const { updatedValue, timeZone } = fetchMobileNumber(obj);
                                    updatePreferredSoContactMethodDetails(
                                      type,
                                      removeXSSScripts(updatedValue),
                                      timeZone
                                    );
                                  }}
                                />
                              )}
                            {type === 'whatsapp' &&
                              (checkedSpecialContactItems[name] || formData.tip_checked_details.includes(name)) && (
                                <PhoneNumberField
                                  label={field}
                                  inputValue={removeXSSScripts(sotripWhatsAppNumber)}
                                  mobileInputVal={sotripWhatsAppNumber}
                                  disabled={false}
                                  inputErrorMsg=""
                                  isNonChinaMobileEnabled={true}
                                  dropdownTimeZoneOptions={countriesDialTimeZone}
                                  defaultTimeZoneOption={sotripWhatsAppNumberTimezone}
                                  fetchMobileNumber={(obj: any) => {
                                    const { updatedValue, timeZone } = fetchMobileNumber(obj);
                                    updatePreferredSoContactMethodDetails(
                                      type,
                                      removeXSSScripts(updatedValue),
                                      timeZone
                                    );
                                  }}
                                />
                              )}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </form>
    );
  };

  /**
   * Render Accessibility and disability Form
   */
  const renderFormAccessibility = () => {
    return (
      <form method="post" data-testid="create-pet-detail-form">
        <div className=" col-12 col-xl-10 px-0 isActive">
          <div className="d-flex justify-content-between align-items-center flex-row flex-row-desktop">
            <div className="row accesref">
              {accessOptionsData.map((checkbox, index) => (
                <div key={`checkbox-${index}`} className="col-md-6">
                  <CheckBox
                    checkboxName={checkbox.name}
                    checkboxLabel={checkbox.label}
                    checked={checkedItems[checkbox.name] || formData.accessiblity_details.includes(checkbox.label)}
                    onChange={handleAccessCheckboxChange}
                    checkboxId={`checkbox-${index}`}
                    data-testid={`checkbox-${checkbox.name}`}
                    key={`checkbox-${index}`}
                    value={checkbox.label}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-6 flex-row p-0">
            <TextArea
              id={`${inputId}-acessibilityDisabilityNotesArea`}
              key="acessibilityDisabilityNotesArea"
              name="acessibilityDisabilityNotesArea"
              label="acessibilityDisabilityNotesArea"
              placeHolderText={props?.i18nMap?.pleaseAddNotes ?? 'Please add notes here'}
              getInputValue={(val: string) => {
                setFormData({ ...formData, accessibility_notes: val });
              }}
              inputValue={removeXSSScripts(formData?.accessibility_notes)}
              maxLength={255}
              messageError={errorMessage1}
            ></TextArea>
          </div>
        </div>
      </form>
    );
  };

  const [filteredPreferredContactData, setFilteredPreferredContactData] = useState([]);
  const [tripEmailCheckbox, setTripEmailCheckbox] = useState(false);
  const [tripPhoneCheckbox, setTripPhoneCheckbox] = useState(false);
  const [tripTextCheckbox, setTripTextCheckbox] = useState(false);
  const [tripWechatCheckbox, setTripWechatCheckbox] = useState(false);
  const [tripWhatsappCheckbox, setTripWhatsappCheckbox] = useState(false);
  const [weChatContact, setWeChatContact] = useState('1');
  const [whatsappContact, setWhatsappContact] = useState('1');
  useEffect(() => {
    setFilteredPreferredContactData(filterContactData(preferredContactCheckboxData, formData, props));
    setTripEmailCheckbox(formData?.tripEmailCheckbox);
    setTripPhoneCheckbox(formData?.tripPhoneCheckbox);
    setTripTextCheckbox(formData?.tripTextCheckbox);
    setTripWechatCheckbox(formData?.tripWechatCheckbox);
    setTripWhatsappCheckbox(formData?.tripWhatsappCheckbox);
    setWeChatContact(formData?.property_config?.wechat_contact);
    setWhatsappContact(formData?.property_config?.whatsapp_contact);
  }, [formData, props]);
  /**
   * Trip Contact Preference
   */
  const passengerOptions = Array.from({ length: 10 }, (_, i) => ({
    value: (i + 1).toString(),
    label: `${i + 1}`,
  }));
  const renderFormTripContact = () => {
    // Use the first 3 items from specialCheckboxData if filteredSpecialContactData is empty or null
    const contactDataToUse =
      filteredPreferredContactData && filteredPreferredContactData.length > 0
        ? filteredPreferredContactData
        : preferredContactCheckboxData.slice(0, 3);
    return (
      <form method="post" data-testid="trip-contact-details">
        <div className="p-0 trip-contact-details col-md-9">
          {contactDataToUse.map(
            (
              /* eslint-disable  @typescript-eslint/no-explicit-any */
              { name, label, field, type }: any
            ) => (
              <div key={name} className="trip-contact-check">
                <CheckBox
                  checkboxName={name}
                  onChange={e => handleCheckboxChange(type, e.target.checked)}
                  checked={
                    (type === 'email' && tripEmailCheckbox) ||
                    (type === 'phone' && tripPhoneCheckbox) ||
                    (type === 'text' && tripTextCheckbox) ||
                    (type === 'wechat' && tripWechatCheckbox) ||
                    (type === 'whatsapp' && tripWhatsappCheckbox)
                  }
                  checkboxLabel={label}
                  checkboxId={`${name}`}
                  data-testid={`checkbox-${name}`}
                />
                {type === 'email' && tripEmailCheckbox && (
                  <InputTextField
                    label={field}
                    //placeHolderText={customerEmail}
                    inputValue={removeXSSScripts(customerEmail)}
                    showErrorMessage={!validUserEmail || !!errors?.errorTripEmail || !!customError.errorTripEmail}
                    messageToShow={customError?.errorTripEmail ? customError?.errorTripEmail : ''}
                    setErrorHtml={true}
                    messageClass="error-label"
                    getInputProps={() => ({
                      autoComplete: 'off',
                      id: `${field}`,
                      onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
                    })}
                    getLabelProps={() => ({
                      htmlFor: `${field}`,
                    })}
                    className={clsx(
                      'm-input-field m-checkbox mt-2 mb-3',
                      !validUserEmail || !!errors?.errorTripEmail || !!customError.errorTripEmail
                        ? 'is-error'
                        : tripEmail
                        ? 'is-active'
                        : ''
                    )}
                    inputMaxLength={255}
                    getInputValue={val => {
                      setTripEmail(val);
                      updatePreferredContactMethodDetails(type, removeXSSScripts(val), '');
                      if (val.length >= 255) {
                        setCustomError({ ...customError, errorTripEmail: errorMessage1 });
                      } else {
                        setCustomError({ ...customError, errorTripEmail: '' });
                      }
                    }}
                    onBlur={(val: any) => {
                      const newValue = val.target.value;
                      if (newValue.length >= 255) {
                        setCustomError({ ...customError, errorTripEmail: errorMessage1 });
                      } else {
                        setCustomError({ ...customError, errorTripEmail: '' });
                      }
                    }}
                    infoLabel={field}
                  />
                )}
                {type === 'phone' && tripPhoneCheckbox && (
                  <PhoneNumberField
                    label={field}
                    inputValue={removeXSSScripts(tripPhoneNumber)}
                    mobileInputVal={removeXSSScripts(tripPhoneNumber)}
                    disabled={false}
                    inputErrorMsg={hasError.tripPhoneNumberError ? labels.tripContacPhoneErrorMessage : ''}
                    inputTimezoneError={hasError.tripPhoneNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
                    clearTimezoneError={() => setHasError({ ...hasError, tripPhoneNumberTimezoneError: '' })}
                    isNonChinaMobileEnabled={true}
                    dropdownTimeZoneOptions={countriesDialTimeZone}
                    defaultTimeZoneOption={tripPhoneNumberTimezone}
                    fetchMobileNumber={(obj: any) => {
                      const { updatedValue, timeZone } = fetchMobileNumber(obj);

                      // const { phoneNumber } = obj; // Assuming obj contains the phoneNumber

                      setTripPhoneNumber(removeXSSScripts(updatedValue));
                      setHasError({ ...hasError, tripPhoneNumberError: '' });
                      updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
                    }}
                  />
                )}
                {type === 'text' && tripTextCheckbox && (
                  <PhoneNumberField
                    label={field}
                    inputValue={removeXSSScripts(tripTextNumber)}
                    mobileInputVal={tripTextNumber}
                    disabled={false}
                    inputErrorMsg={hasError.tripTextNumberError ? labels.tripContacTextErrorMessage : ''}
                    inputTimezoneError={hasError.tripTextNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
                    clearTimezoneError={() => setHasError({ ...hasError, tripTextNumberTimezoneError: '' })}
                    isNonChinaMobileEnabled={true}
                    dropdownTimeZoneOptions={countriesDialTimeZone}
                    defaultTimeZoneOption={tripTextNumberTimezone}
                    fetchMobileNumber={(obj: any) => {
                      const { updatedValue, timeZone } = fetchMobileNumber(obj);
                      setTripTextNumber(updatedValue);
                      setHasError({ ...hasError, tripTextNumberError: '' });
                      updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
                    }}
                  />
                )}
                {weChatContact === '1' && type === 'wechat' && tripWechatCheckbox && (
                  <PhoneNumberField
                    label={field}
                    inputValue={removeXSSScripts(tripWeChatNumber)}
                    mobileInputVal={tripWeChatNumber}
                    disabled={false}
                    inputErrorMsg={hasError.tripWeChatNumberError ? labels.tripContacWeChatErrorMessage : ''}
                    inputTimezoneError={hasError.tripWeChatNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
                    clearTimezoneError={() => setHasError({ ...hasError, tripWeChatNumberTimezoneError: '' })}
                    isNonChinaMobileEnabled={true}
                    dropdownTimeZoneOptions={countriesDialTimeZone}
                    defaultTimeZoneOption={tripWeChatNumberTimezone}
                    fetchMobileNumber={(obj: any) => {
                      const { updatedValue, timeZone } = fetchMobileNumber(obj);
                      //setTripTextNumber(updatedValue);
                      setHasError({ ...hasError, tripWeChatNumberError: '' });
                      updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
                    }}
                  />
                )}
                {whatsappContact === '1' && type === 'whatsapp' && tripWhatsappCheckbox && (
                  <PhoneNumberField
                    label={field}
                    inputValue={removeXSSScripts(tripWhatsAppNumber)}
                    mobileInputVal={tripWhatsAppNumber}
                    disabled={false}
                    inputErrorMsg={hasError.tripWhatsAppNumberError ? labels.tripContacWhatsAppErrorMessage : ''}
                    inputTimezoneError={hasError.tripWhatsAppNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
                    clearTimezoneError={() => setHasError({ ...hasError, tripWhatsAppNumberTimezoneError: '' })}
                    isNonChinaMobileEnabled={true}
                    dropdownTimeZoneOptions={countriesDialTimeZone}
                    defaultTimeZoneOption={tripWhatsAppNumberTimezone}
                    fetchMobileNumber={(obj: any) => {
                      const { updatedValue, timeZone } = fetchMobileNumber(obj);
                      //setTripTextNumber(updatedValue);
                      setHasError({ ...hasError, tripWhatsAppNumberError: '' });
                      updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
                    }}
                  />
                )}
              </div>
            )
          )}
        </div>
      </form>
    );
  };

  const renderFormTripContactguestDetailV2 = () => {
    // Step 1: Pick contact data (max 5 items)
    let contactDataToUse =
      filteredPreferredContactData && filteredPreferredContactData.length > 0
        ? filteredPreferredContactData
        : preferredContactCheckboxData.slice(0, 5);

    // Step 2: Filter out contacts that should NOT be shown
    contactDataToUse = contactDataToUse.filter(item => {
      if (item.type === 'wechat' && weChatContact !== '1') return false;
      if (item.type === 'whatsapp' && whatsappContact !== '1') return false;
      return true; // keep email, phone, text always
    });

    if (contactDataToUse.length === 0) {
      return null; // nothing to show
    }

    // Step 3: Split into two columns (max 3 in first, rest in second)
    const firstColumn = contactDataToUse.slice(0, 3);
    const secondColumn = contactDataToUse.slice(3, 5);

    // Step 4: Helper function for rendering items
    const renderContactItem = ({ name, label, field, type }: any) => {
      const isChecked =
        (type === 'email' && tripEmailCheckbox) ||
        (type === 'phone' && tripPhoneCheckbox) ||
        (type === 'text' && tripTextCheckbox) ||
        (type === 'wechat' && tripWechatCheckbox) ||
        (type === 'whatsapp' && tripWhatsappCheckbox);

      return (
        <div key={name} className="trip-contact-check">
          <CheckBox
            checkboxName={name}
            onChange={e => handleCheckboxChange(type, e.target.checked)}
            checked={isChecked}
            checkboxLabel={label}
            checkboxId={name}
            data-testid={`checkbox-${name}`}
          />

          {/* Email */}
          {type === 'email' && tripEmailCheckbox && (
            <InputTextField
              label={field}
              inputValue={removeXSSScripts(customerEmail)}
              showErrorMessage={!validUserEmail || !!errors?.errorTripEmail || !!customError.errorTripEmail}
              messageToShow={customError?.errorTripEmail ? customError?.errorTripEmail : ''}
              setErrorHtml={true}
              messageClass="error-label"
              getInputProps={() => ({
                autoComplete: 'off',
                id: `${field}`,
                onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
              })}
              getLabelProps={() => ({
                htmlFor: `${field}`,
              })}
              className={clsx(
                'm-input-field m-checkbox mt-2 mb-3',
                !validUserEmail || !!errors?.errorTripEmail || !!customError.errorTripEmail
                  ? 'is-error'
                  : tripEmail
                  ? 'is-active'
                  : ''
              )}
              inputMaxLength={255}
              getInputValue={val => {
                setTripEmail(val);
                updatePreferredContactMethodDetails(type, removeXSSScripts(val), '');
                if (val.length >= 255) {
                  setCustomError({
                    ...customError,
                    errorTripEmail: errorMessage1,
                  });
                } else {
                  setCustomError({ ...customError, errorTripEmail: '' });
                }
              }}
              onBlur={(val: any) => {
                const newValue = val.target.value;
                if (newValue.length >= 255) {
                  setCustomError({
                    ...customError,
                    errorTripEmail: errorMessage1,
                  });
                } else {
                  setCustomError({ ...customError, errorTripEmail: '' });
                }
              }}
              infoLabel={field}
            />
          )}

          {/* Phone */}
          {type === 'phone' && isChecked && (
            <PhoneNumberField
              label={field}
              inputValue={removeXSSScripts(tripPhoneNumber)}
              mobileInputVal={tripPhoneNumber}
              disabled={false}
              inputErrorMsg={hasError.tripPhoneNumberError ? labels.tripContacPhoneErrorMessage : ''}
              inputTimezoneError={hasError.tripPhoneNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
              clearTimezoneError={() => setHasError({ ...hasError, tripPhoneNumberTimezoneError: '' })}
              isNonChinaMobileEnabled={true}
              dropdownTimeZoneOptions={countriesDialTimeZone}
              defaultTimeZoneOption={tripPhoneNumberTimezone}
              fetchMobileNumber={(obj: any) => {
                const { updatedValue, timeZone } = fetchMobileNumber(obj);
                setTripPhoneNumber(updatedValue);
                setHasError({ ...hasError, tripPhoneNumberError: '' });
                updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
              }}
            />
          )}

          {/* Text */}
          {type === 'text' && isChecked && (
            <PhoneNumberField
              label={field}
              inputValue={removeXSSScripts(tripTextNumber)}
              mobileInputVal={tripTextNumber}
              disabled={false}
              inputErrorMsg={hasError.tripTextNumberError ? labels.tripContacTextErrorMessage : ''}
              inputTimezoneError={hasError.tripTextNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
              clearTimezoneError={() => setHasError({ ...hasError, tripTextNumberTimezoneError: '' })}
              isNonChinaMobileEnabled={true}
              dropdownTimeZoneOptions={countriesDialTimeZone}
              defaultTimeZoneOption={tripTextNumberTimezone}
              fetchMobileNumber={(obj: any) => {
                const { updatedValue, timeZone } = fetchMobileNumber(obj);
                setTripTextNumber(updatedValue);
                setHasError({ ...hasError, tripTextNumberError: '' });
                updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
              }}
            />
          )}

          {/* WeChat */}
          {type === 'wechat' && isChecked && (
            <PhoneNumberField
              label={field}
              inputValue={removeXSSScripts(tripWeChatNumber)}
              mobileInputVal={tripWeChatNumber}
              disabled={false}
              inputErrorMsg={hasError.tripWeChatNumberError ? labels.tripContacWeChatErrorMessage : ''}
              inputTimezoneError={hasError.tripWeChatNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
              clearTimezoneError={() => setHasError({ ...hasError, tripWeChatNumberTimezoneError: '' })}
              isNonChinaMobileEnabled={true}
              dropdownTimeZoneOptions={countriesDialTimeZone}
              defaultTimeZoneOption={tripWeChatNumberTimezone}
              fetchMobileNumber={(obj: any) => {
                const { updatedValue, timeZone } = fetchMobileNumber(obj);
                setHasError({ ...hasError, tripWeChatNumberError: '' });
                updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
              }}
            />
          )}

          {/* WhatsApp */}
          {type === 'whatsapp' && isChecked && (
            <PhoneNumberField
              label={field}
              inputValue={removeXSSScripts(tripWhatsAppNumber)}
              mobileInputVal={tripWhatsAppNumber}
              disabled={false}
              inputErrorMsg={hasError.tripWhatsAppNumberError ? labels.tripContacWhatsAppErrorMessage : ''}
              inputTimezoneError={hasError.tripWhatsAppNumberTimezoneError ? labels.tripTimezoneErrorMessage : ''}
              clearTimezoneError={() => setHasError({ ...hasError, tripWhatsAppNumberTimezoneError: '' })}
              isNonChinaMobileEnabled={true}
              dropdownTimeZoneOptions={countriesDialTimeZone}
              defaultTimeZoneOption={tripWhatsAppNumberTimezone}
              fetchMobileNumber={(obj: any) => {
                const { updatedValue, timeZone } = fetchMobileNumber(obj);
                setHasError({ ...hasError, tripWhatsAppNumberError: '' });
                updatePreferredContactMethodDetails(type, removeXSSScripts(updatedValue), timeZone);
              }}
            />
          )}
        </div>
      );
    };

    // Step 5: Render grid
    return (
      <form method="post" data-testid="trip-contact-details">
        <div className="trip-contact-grid toggle-trip">
          {/* First column (max 3 items) */}
          <div className="flex flex-col gap-4">{firstColumn.map(item => renderContactItem(item))}</div>

          {/* Second column (if needed) */}
          {secondColumn.length > 0 && (
            <div className="flex flex-col gap-4">{secondColumn.map(item => renderContactItem(item))}</div>
          )}
        </div>
      </form>
    );
  };

  /**
   * Transportation Detals-sahana
   */
  const renderFormTripDetails = () => {
    return (
      <form method="post" data-testid="trip-arrival-departure-details">
        <div>
          <div className=" toggle-message">
            <div
              className={`toggle-width ${
                (formData?.property_config?.survey_arrival_alert &&
                  formData?.property_config?.survey_arrival_alert !== '') ||
                (props.property_config?.survey_arrival_alert && props.property_config?.survey_arrival_alert !== '')
                  ? 'half-width'
                  : ''
              }`}
            >
              <Text
                element={Types.tags.paragraph}
                fontSize={Types.size.medium}
                dangerouslySetInnerHTML={{ __html: labels.transportationDetailsText }}
                customClass="mb-2 subTitle"
              ></Text>
              {!guestDetailV2 && (
                <div
                  className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                    needArrivalDepartureAssistance === 'Yes' && 'mb-2'
                  }`}
                >
                  <p>
                    <span className="sr-only">
                      Would you like us to assist with coordinating your travel arrangements for your arrival or
                      departure?
                    </span>
                  </p>
                </div>
              )}
            </div>
            {needArrivalDepartureAssistance === 'Yes' &&
              ((formData?.property_config?.survey_arrival_alert &&
                formData?.property_config?.survey_arrival_alert !== '') ||
                (props.property_config?.survey_arrival_alert &&
                  props.property_config?.survey_arrival_alert !== '')) && (
                <div className="toggle-width">
                  <Messages
                    messageType={'info'}
                    messageHeading={
                      formData?.property_config?.survey_arrival_alert ?? props.property_config?.survey_arrival_alert
                    }
                    className="red-border mb-3"
                  ></Messages>
                </div>
              )}
          </div>
          {needArrivalDepartureAssistance === 'Yes' && (
            <div>
              <Text
                element={Types.tags.paragraph}
                fontSize={Types.size.medium}
                dangerouslySetInnerHTML={{ __html: labels.transportationSubHeading }}
                customClass="mb-3 subTitle"
              ></Text>
              <div className=" d-flex  flex-row-desktop">
                <div>
                  <Text
                    element={Types.tags.paragraph}
                    fontSize={Types.size.medium}
                    dangerouslySetInnerHTML={{ __html: labels.arrivalText }}
                    customClass="mb-2 subTitle subTitleText"
                  ></Text>

                  <div className="m-form-group custom-select-wrapper arrival-departure">
                    <select
                      id={`${inputId}-arrivalmethod`}
                      name="arrivalmethod"
                      value={formData?.arrival_method}
                      onChange={e => {
                        const arrivalMethod = e.target.value;
                        setHasError({ ...hasError, arrivalMethodError: '' });
                        setFormData({
                          ...formData,
                          arrival_method: arrivalMethod,
                          arrivalInfo: '',
                          arrivalFlightNumber: '',
                          arrivalPassengers: '',
                        });
                      }}
                      className={`selectBox selectBox-xl ${hasError.arrivalMethodError ? 'is-error' : ''}`}
                      required
                    >
                      <option value="" disabled selected hidden>
                        Please select
                      </option>
                      {transportationType.map((option, index) => (
                        <option key={index} value={option.value} role="option">
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {hasError.arrivalMethodError && (
                    <div className="error-container mt-2">
                      <span className="error-icon">
                        <i className="icon-alert"></i>
                      </span>
                      <Text
                        element={Types.tags.paragraph}
                        fontSize={Types.size.extraSmall}
                        customClass={`error-message time`}
                        dangerouslySetInnerHTML={{ __html: labels.arrivalMethodErrorMessage }}
                      ></Text>
                    </div>
                  )}
                  {isVisible['div18'] && (
                    <div className="d-flex justify-content-between datetimeDiv">
                      <div
                        className={`date-picker-container ${
                          telephonetime || formData.transportation_arrival_date ? 'addVal' : ''
                        }`}
                        ref={preferredCalendarRef}
                      >
                        <input
                          type="text"
                          className={`date-picker ${hasError.arrivalDateError ? 'is-error' : ''}`}
                          aria-label="date-picker"
                          value={telephonetime || formData.transportation_arrival_date}
                          onClick={() => handleInputClick('preferred')}
                          placeholder="yyyy-mm-dd"
                          readOnly
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const newTime = e.target.value;
                            if (newTime && !hasError.arrivalDateError) {
                              setHasError(prev => ({ ...prev, arrivalDateError: '' }));
                            }
                            setTelephoneTime(newTime);
                            setFormData({
                              ...formData,
                              transportation_arrival_date: newTime,
                            });
                          }}
                        />
                        <span className="input-icon">
                          {/* You can use an icon from a library like FontAwesome or an image here */}
                          <i className="icon-stay-dates"></i>
                        </span>
                        {showPreferredCalendar && (
                          <Calendar
                            singleDatePicker={true}
                            className="singledatepicker"
                            startFromToday={false}
                            variation=""
                            startDate={startArrivalDate}
                            endDate={null}
                            focusedInput={null}
                            setDateHandler={date => {
                              handleDateChange(date); // Update preferredDate and hide calendar
                            }}
                            setFocusedInputHandler={(): void => {
                              console.log('setFocusedInputHandler');
                            }}
                            nightsLabel=""
                            nightLabel=""
                            disableHoverToolTip={true}
                            maxAllowedDays={CALENDAR_MAX_ALLOWED_DAYS}
                            weekdays={SHORT_WEEK_DAYS}
                            months={LONG_MONTH_NAME}
                            weekdaysLong={LONG_WEEK_DAYS_NAME}
                            weekdaysShort={SHORT_WEEK_DAYS}
                            monthsShort={SHORT_MONTH_NAME}
                            firstDayOfWeek="0"
                            numberOfMonths={1}
                            showOutsideDays={true}
                            fixedWeeks={true}
                            disabledDays={disabledDays}
                            enableOutsideDaysClick={false}
                          />
                        )}
                        {hasError.arrivalDateError && (
                          <div className="error-container mt-2">
                            <span className="error-icon">
                              <i className="icon-alert"></i>
                            </span>
                            <Text
                              element={Types.tags.paragraph}
                              fontSize={Types.size.extraSmall}
                              customClass={`error-message time`}
                              dangerouslySetInnerHTML={{ __html: labels.arrivalDateErrorMessage }}
                            ></Text>
                          </div>
                        )}
                      </div>

                      <div
                        className={`time-picker d-flex align-items-end flex-column ${
                          hasError.arrivalTime ? 'has-error' : ''
                        }`}
                      >
                        <TimePicker
                          id={`${inputId}-PreferredDateArrivalTiming`}
                          name="PreferredDateArrivalTiming"
                          time={selectedTimes.telephonetime2 || formData?.transportation_arrival_time}
                          onChange={newTime => handleTimeChange(newTime, 'telephonetime2')}
                          hasError={hasError.arrivalTime}
                        />
                        <Text
                          element={Types.tags.paragraph}
                          fontSize={Types.size.small}
                          dangerouslySetInnerHTML={{ __html: fragmentString2 }}
                          customClass="time-text mt-2"
                        ></Text>
                        {hasError.arrivalTime && (
                          <div className="error-container ">
                            <span className="error-icon">
                              <i className="icon-alert"></i>
                            </span>
                            <Text
                              element={Types.tags.paragraph}
                              fontSize={Types.size.extraSmall}
                              customClass={`error-message time`}
                              dangerouslySetInnerHTML={{ __html: labels.arrivalTimeErrorMessage }}
                            ></Text>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {formData.arrival_method && (
                    // Example static data

                    // Fields
                    <form>
                      {/* Show only if arrival method is NOT 'Car' */}
                      {formData.arrival_method !== 'Car' && (
                        <>
                          <div className="d-flex justify-content-between datetimeDiv arrivaldata">
                            {/* Airport / Address / Train Station Field */}
                            <div className="m-form-group">
                              <InputTextField
                                label="arrivalInfo"
                                placeHolderText={
                                  formData.arrival_method === 'Private Plane'
                                    ? 'Add airport here'
                                    : formData.arrival_method === 'Commercial Airplane'
                                    ? 'Add airport here'
                                    : formData.arrival_method === 'Train'
                                    ? 'Add train station'
                                    : 'Add address here' // Other / Local Destination
                                }
                                inputValue={removeXSSScripts(formData.arrivalInfo)}
                                inputMaxLength={255}
                                getInputProps={() => ({
                                  autoComplete: 'off',
                                  id: `${inputId}-arrivalInfo`,
                                  onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
                                })}
                                getLabelProps={() => ({
                                  htmlFor: `${inputId}-arrivalInfo`,
                                })}
                                className={clsx('m-input-field', formData?.arrivalInfo ? 'is-active' : '')}
                                getInputValue={(val: string) => {
                                  setFormData({ ...formData, arrivalInfo: removeXSSScripts(val) });
                                }}
                                infoLabel="arrivalInfo"
                              />
                            </div>

                            {/* Flight / Train Number Field (only for Plane/Train) */}
                            {(formData.arrival_method === 'Private Plane' ||
                              formData.arrival_method === 'Commercial Airplane' ||
                              formData.arrival_method === 'Train') && (
                              <div className="m-form-group">
                                <InputTextField
                                  label="arrivalFlightNumber"
                                  placeHolderText={
                                    formData.arrival_method === 'Train' ? 'Add train # here' : 'Add flight # here'
                                  }
                                  inputValue={removeXSSScripts(formData.arrivalFlightNumber)}
                                  inputMaxLength={255}
                                  getInputProps={() => ({
                                    autoComplete: 'off',
                                    id: `${inputId}-arrivalFlightNumber`,
                                    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
                                  })}
                                  getLabelProps={() => ({
                                    htmlFor: `${inputId}-arrivalFlightNumber`,
                                  })}
                                  className={clsx('m-input-field', formData?.arrivalFlightNumber ? 'is-active' : '')}
                                  getInputValue={(val: string) => {
                                    setFormData({ ...formData, arrivalFlightNumber: removeXSSScripts(val) });
                                  }}
                                  infoLabel="arrivalFlightNumber"
                                />
                              </div>
                            )}
                          </div>
                          {/* Number of Passengers (show for all except Car) */}
                          <div className="m-form-group custom-select-wrapper arrival-departure">
                            <select
                              name="passengers"
                              value={formData.arrivalPassengers}
                              className="selectBox selectBox-xl"
                              onChange={e => setFormData({ ...formData, arrivalPassengers: e.target.value })}
                              required
                            >
                              <option value="" disabled hidden>
                                Number of passengers
                              </option>
                              {passengerOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                    </form>
                  )}
                </div>

                <div className="departure-margin">
                  <Text
                    element={Types.tags.paragraph}
                    fontSize={Types.size.medium}
                    dangerouslySetInnerHTML={{ __html: labels.departureText }}
                    customClass="mb-2 subTitle"
                  ></Text>

                  <div className="m-form-group custom-select-wrapper arrival-departure">
                    <select
                      id={`${inputId}-departuremethod`}
                      name="departuremethod"
                      value={formData?.departure_method}
                      onChange={e => {
                        const departureMethod = e.target.value;
                        setHasError({ ...hasError, departureMethodError: '' });
                        setFormData({
                          ...formData,
                          departure_method: departureMethod,
                          departureInfo: '',
                          departureFlightNumber: '',
                          departurePassengers: '',
                        });
                      }}
                      className={`selectBox selectBox-xl ${hasError.departureMethodError ? 'is-error' : ''}`}
                      required
                    >
                      <option value="" disabled selected hidden>
                        Please select
                      </option>
                      {transportationType.map((option, index) => (
                        <option key={index} value={option.value} role="option">
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {hasError.departureMethodError && (
                    <div className="error-container mt-2">
                      <span className="error-icon">
                        <i className="icon-alert"></i>
                      </span>
                      <Text
                        element={Types.tags.paragraph}
                        fontSize={Types.size.extraSmall}
                        customClass={`error-message time`}
                        dangerouslySetInnerHTML={{ __html: labels.departureMethodErrorMessage }}
                      ></Text>
                    </div>
                  )}
                  {isVisible['div19'] && (
                    <div>
                      <div className="d-flex justify-content-between pl-0 datetimeDiv">
                        <div
                          className={`date-picker-container ${
                            deptteletime || formData.transportation_departure_date ? 'addVal' : ''
                          }`}
                          ref={alternateCalendarRef}
                        >
                          <input
                            type="text"
                            className={`date-picker ${hasError.departureDateError ? 'is-error' : ''}`}
                            aria-label="date-picker1"
                            value={formData.transportation_departure_date}
                            placeholder="yyyy-mm-dd"
                            readOnly
                            onClick={() => handleInputClick('alternative')}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              const newTime = e.target.value;
                              setDeptteleTime(newTime);
                              setHasError({ ...hasError, departureDateError: '' });
                              setFormData({
                                ...formData,
                                transportation_departure_date: newTime,
                              });
                            }}
                          />
                          <span className="input-icon">
                            {/* You can use an icon from a library like FontAwesome or an image here */}
                            <i className="icon-stay-dates"></i>
                          </span>
                          {showAlternateCalendar && (
                            <Calendar
                              singleDatePicker={true}
                              className="singledatepicker"
                              startFromToday={false}
                              variation="DESKTOP"
                              startDate={startDepartureDate}
                              endDate={null}
                              focusedInput={null}
                              setDateHandler={date => {
                                handleAlternateDateChange(date); // Update preferredDate and hide calendar
                              }}
                              setFocusedInputHandler={(): void => {
                                console.log('setFocusedInputHandler');
                              }}
                              nightsLabel=""
                              nightLabel=""
                              disableHoverToolTip={true}
                              maxAllowedDays={CALENDAR_MAX_ALLOWED_DAYS}
                              weekdays={SHORT_WEEK_DAYS}
                              months={LONG_MONTH_NAME}
                              weekdaysLong={LONG_WEEK_DAYS_NAME}
                              weekdaysShort={SHORT_WEEK_DAYS}
                              monthsShort={SHORT_MONTH_NAME}
                              firstDayOfWeek="0"
                              numberOfMonths={1}
                              showOutsideDays={true}
                              fixedWeeks={true}
                              disabledDays={disabledDays}
                            />
                          )}
                          {hasError.departureDateError && (
                            <div className="error-container mt-2">
                              <span className="error-icon">
                                <i className="icon-alert"></i>
                              </span>
                              <Text
                                element={Types.tags.paragraph}
                                fontSize={Types.size.extraSmall}
                                customClass={`error-message time`}
                                dangerouslySetInnerHTML={{ __html: labels.departureDateErrorMessage }}
                              ></Text>
                            </div>
                          )}
                        </div>

                        <div
                          className={`time-picker d-flex align-items-end flex-column ${
                            hasError.departureTime ? 'has-error' : ''
                          }`}
                        >
                          <TimePicker
                            id={`${inputId}-PreferredDateDeparture`}
                            name="PreferredDateDeparture"
                            time={selectedTimes.deptteletime2 || formData.transportation_departure_time}
                            onChange={newTime => handleTimeChange(newTime, 'deptteletime2')}
                            hasError={hasError.departureTime}
                          />
                          <Text
                            element={Types.tags.paragraph}
                            fontSize={Types.size.small}
                            dangerouslySetInnerHTML={{ __html: fragmentString2 }}
                            customClass="time-text mt-2"
                          ></Text>
                          {hasError.departureTime && (
                            <div className="error-container ">
                              <span className="error-icon">
                                <i className="icon-alert"></i>
                              </span>
                              <Text
                                element={Types.tags.paragraph}
                                fontSize={Types.size.extraSmall}
                                customClass={`error-message time`}
                                dangerouslySetInnerHTML={{ __html: labels.departureTimeErrorMessage }}
                              ></Text>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {formData.departure_method && (
                    // Example static data

                    // Fields
                    <form>
                      {/* Show only if departure method is NOT 'Car' */}
                      {formData.departure_method !== 'Car' && (
                        <>
                          <div className="d-flex justify-content-between datetimeDiv arrivaldata">
                            {/* Airport / Address / Train Station Field */}
                            <div className="m-form-group">
                              <InputTextField
                                label="departureInfo"
                                placeHolderText={
                                  formData.departure_method === 'Private Plane'
                                    ? 'Add airport here'
                                    : formData.departure_method === 'Commercial Airplane'
                                    ? 'Add airport here'
                                    : formData.departure_method === 'Train'
                                    ? 'Add train station'
                                    : 'Add address here' // Other
                                }
                                inputValue={removeXSSScripts(formData.departureInfo)}
                                inputMaxLength={255}
                                getInputProps={() => ({
                                  autoComplete: 'off',
                                  id: `${inputId}-departureInfo`,
                                  onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
                                })}
                                getLabelProps={() => ({
                                  htmlFor: `${inputId}-departureInfo`,
                                })}
                                className={clsx('m-input-field', formData?.departureInfo ? 'is-active' : '')}
                                getInputValue={(val: string) => {
                                  setFormData({ ...formData, departureInfo: removeXSSScripts(val) });
                                }}
                                infoLabel="departureInfo"
                              />
                            </div>

                            {/* Flight / Train Number Field (only for Plane/Train) */}
                            {(formData.departure_method === 'Private Plane' ||
                              formData.departure_method === 'Commercial Airplane' ||
                              formData.departure_method === 'Train') && (
                              <div className="m-form-group">
                                <InputTextField
                                  label="departureFlightNumber"
                                  placeHolderText={
                                    formData.departure_method === 'Train' ? 'Add train # here' : 'Add flight # here'
                                  }
                                  inputValue={removeXSSScripts(formData.departureFlightNumber)}
                                  inputMaxLength={255}
                                  getInputProps={() => ({
                                    autoComplete: 'off',
                                    id: `${inputId}-departureFlightNumber`,
                                    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => handlePaste(e),
                                  })}
                                  getLabelProps={() => ({
                                    htmlFor: `${inputId}-departureFlightNumber`,
                                  })}
                                  className={clsx('m-input-field', formData?.departureFlightNumber ? 'is-active' : '')}
                                  getInputValue={(val: string) => {
                                    setFormData({
                                      ...formData,
                                      departureFlightNumber: removeXSSScripts(val),
                                    });
                                  }}
                                  infoLabel="departureFlightNumber"
                                />
                              </div>
                            )}
                          </div>

                          {/* Number of Passengers (show for all except Car) */}
                          <div className="m-form-group custom-select-wrapper arrival-departure">
                            <select
                              name="passengers"
                              value={formData.departurePassengers}
                              className="selectBox selectBox-xl"
                              onChange={e => setFormData({ ...formData, departurePassengers: e.target.value })}
                              required
                            >
                              <option value="" disabled hidden>
                                Number of passengers
                              </option>
                              {passengerOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                    </form>
                  )}
                </div>
              </div>
            </div>
          )}
          {needArrivalDepartureAssistance === 'Yes' && (
            <div className="mt-2">
              <Text
                element={Types.tags.paragraph}
                fontSize={Types.size.medium}
                dangerouslySetInnerHTML={{ __html: labels.subTitle18 }}
                customClass="mb-2 subTitle"
              ></Text>
              <div className="col-md-10 pl-0">
                <TextArea
                  id={`${inputId}-tripGuestNotesArea`}
                  key="tripGuestNotesArea"
                  name="tripGuestNotesArea"
                  label="tripGuestNotesArea"
                  placeHolderText={props?.i18nMap?.pleaseAddNotes ?? 'Please Add Notes Here'}
                  getInputValue={(val: string) => {
                    setFormData({ ...formData, arrival_dept_notes: val });
                  }}
                  inputValue={removeXSSScripts(formData?.arrival_dept_notes)}
                  maxLength={255}
                  messageError={errorMessage1}
                ></TextArea>
              </div>
            </div>
          )}
        </div>
      </form>
    );
  };

  /**
   * Toast Message
   */

  const handleClose = () => {
    setIsShowMessageToast(false); // Update state to hide the toast message
    setIsShowErrorMessageToast(false);
    setShowVaribaleErrorMessage(false);
    setFormValidation(false);
  };
  useEffect(() => {
    if (!isShowErrorMessageToast) {
      setErrors({
        ...errors,
        titleError: '',
        firstNameError: '',
        lastNameError: '',
        relationshipTypeError: '',
        childFirstNameError: '',
        childLastNameError: '',
        childAgeError: '',
        childNotesAreaError: '',
        petNameError: '',
        petBreedError: '',
        petNotesAreaError: '',
      });
    }
  }, [isShowErrorMessageToast]);

  // render error message
  const renderErrorMessage = () => {
    return (
      isShowErrorMessageToast && (
        <div className="container toast-message error">
          <div className="row">
            <div className="m-message-modal col-12 col-md-6 col-lg-4">
              <div className="m-message-modal-contentwrap">
                <div className="m-message-inline error-sev1">
                  <div className="m-message-content-wrap">
                    <div className="m-message-content">
                      <span>{toastErrorMessage}</span>
                      <button onClick={handleClose} className="close-button">
                        &#10006;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  // render error message based on variable change
  const renderVariableChangeErrorMessage = () => {
    return (
      <div className="container toast-message error">
        <div className="row">
          <div className="m-message-modal col-12 col-md-6 col-lg-4">
            <div className="m-message-modal-contentwrap">
              <div className="m-message-inline error-sev1">
                <div className="m-message-content-wrap">
                  <div className="m-message-content">
                    <span>Alert: Please add missing information!</span>
                    <button onClick={handleClose} className="close-button">
                      &#10006;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const [title, setTitle] = useState('');

  useEffect(() => {
    setTitle(labels.title);
  }, []);

  const sanitizedNode1 = DOMPurify.sanitize(labels.subTitle19, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString1 = sanitizedNode1.innerHTML;

  const sanitizedNode2 = DOMPurify.sanitize(timeTitle, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString2 = sanitizedNode2.innerHTML;

  // const sanitizedNode3 = DOMPurify.sanitize(labels.subTitle1, { RETURN_DOM: true }) as HTMLElement;
  // const fragmentString3 = sanitizedNode3.innerHTML;
  // const sanitizedNode4 = DOMPurify.sanitize(labels.subTitle2, { RETURN_DOM: true }) as HTMLElement;
  // const fragmentString4 = sanitizedNode4.innerHTML;
  const sanitizedNode5 = DOMPurify.sanitize(labels.subTitle3, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString5 = sanitizedNode5.innerHTML;
  const sanitizedNode6 = DOMPurify.sanitize(labels.subTitle4, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString6 = sanitizedNode6.innerHTML;
  // const sanitizedNode7 = DOMPurify.sanitize(labels.subTitle5, { RETURN_DOM: true }) as HTMLElement;
  // const fragmentString7 = sanitizedNode7.innerHTML;

  // const sanitizedNode8 = DOMPurify.sanitize(labels.guestInformationText, { RETURN_DOM: true }) as HTMLElement;
  // const fragmentString8 = sanitizedNode8.innerHTML;
  const sanitizedNode9 = DOMPurify.sanitize(labels.additionalGuestsText, { RETURN_DOM: true }) as HTMLElement;
  const sanitizedNode15 = DOMPurify.sanitize(labels.addpetText, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString9 = sanitizedNode9.innerHTML;
  const fragmentString15 = sanitizedNode15.innerHTML;
  // const sanitizedNode10 = DOMPurify.sanitize(labels.needsText, { RETURN_DOM: true }) as HTMLElement;
  // const fragmentString10 = sanitizedNode10.innerHTML;
  const sanitizedNode11 = DOMPurify.sanitize(labels.contactPreferencesText, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString11 = sanitizedNode11.innerHTML;
  const sanitizedNode12 = DOMPurify.sanitize(labels.specialOccasionText, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString12 = sanitizedNode12.innerHTML;
  const sanitizedNode13 = DOMPurify.sanitize(labels.additionalRequestsText, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString13 = sanitizedNode13.innerHTML;
  const sanitizedNode14 = DOMPurify.sanitize(labels.summaryText, { RETURN_DOM: true }) as HTMLElement;
  const fragmentString14 = sanitizedNode14.innerHTML;

  const [brandCdSetPage, setBrandCdSetPage] = useState('');
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
  useEffect(() => {
    if (props?.brandCode) {
      if (props?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF'));
      } else {
        setBrandCdSetPage(brandColorSchemeGenerator(props?.brandCode));
      }
    } else {
      if (formData?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF'));
      } else {
        setBrandCdSetPage(brandColorSchemeGenerator(formData?.property_config?.brand_cd || formData?.brandCode));
      }
    }
    if (props?.backgroundImage) {
      setBackgroundImageUrl(props?.backgroundImage);
    } else {
      setBackgroundImageUrl(formData?.property_config?.background_image_url);
    }
  }, [
    formData?.property_config?.background_image_url,
    formData?.property_config?.brand_cd,
    props?.brandCode,
    props?.backgroundImage,
  ]);

  useEffect(() => {
    if (
      props?.isAuthorMode ||
      formData?.property_config?.background_image_url ||
      formData?.property_config?.brand_cd ||
      props?.brandCode ||
      formData?.property_config?.brand_cdprops?.backgroundImage ||
      props?.productSpecificResponse
    ) {
      setIsLoading(false);
    }
  }, [
    props?.isAuthorMode,
    formData?.property_config?.background_image_url,
    formData?.property_config?.brand_cd,
    props?.brandCode,
    props?.backgroundImage,
    props?.productSpecificResponse,
  ]);

  useEffect(() => {
    if (!props.productSpecificResponse || props.productSpecificResponse === null) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [props.productSpecificResponse]);

  const hasAlertMsg = () => {
    return !!document.querySelector('body .alert-msg');
  };

  const validateMandateRef = useRef(ValidateMandateData);
  useEffect(() => {
    validateMandateRef.current = ValidateMandateData;
  });

  useEffect(() => {
    const handler = () => validateMandateRef.current(true);
    window.addEventListener('validate-guest-details', handler);
    return () => window.removeEventListener('validate-guest-details', handler);
  }, []);

  return (
    <div className="aem-GridColumn aem-GridColumn--default--12">
      {isLoading ? (
        <SurveyWrapper
          marshaCode={marshaCode}
          backgroundImage={backgroundImageUrl}
          className="brand-css common-color-set"
          colorScheme={brandCdSetPage}
          alternateId={alternateCID}
          productInfo={marshaCode}
          formPageName="Review"
          formName="Prearrival Travel Form"
          env_api_tile_error_info=""
          prearrival_form_amenities_added_to_plan={formData.prearrivalformamenitiesaddedtoplan}
          prearrival_form_booking_confirmation_id={combinedValue}
          form_prearrival_questions_complete={form_prearrival_questions_complete}
        >
          <StyledGuestDetails className={styleClass}>
            <SurveyWrapperInner>
              <div className="guest-details-page">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="guest-detail-page-wrapper d-flex flex-column container col-12 col-xl-10">
                        <div className="d-flex top-right-content">
                          <div
                            className="skeleton-loader"
                            style={{ width: '120px', height: '20px', marginLeft: '8px' }}
                          ></div>
                          <div
                            className="skeleton-loader"
                            style={{ width: '100px', height: '20px', marginLeft: '8px' }}
                          ></div>
                        </div>
                        <div
                          className="skeleton-loader"
                          style={{ width: '60%', height: '32px', margin: '16px 0' }}
                        ></div>
                        <div
                          className="skeleton-loader"
                          style={{ width: '80%', height: '16px', marginBottom: '16px' }}
                        ></div>
                        <hr className="skeleton-loader" />
                        <div
                          className="skeleton-loader"
                          style={{ width: '40%', height: '24px', margin: '24px 0 8px' }}
                        ></div>
                        <div
                          className="skeleton-loader"
                          style={{ width: '70%', height: '16px', marginBottom: '16px' }}
                        ></div>
                        <hr className="skeleton-loader" />

                        <div
                          className="skeleton-loader"
                          style={{ width: '40%', height: '24px', margin: '24px 0 8px' }}
                        ></div>
                        <div className="skeleton-loader" style={{ width: '150px', height: '20px' }}></div>

                        <hr className="skeleton-loader" />

                        <div
                          className="skeleton-loader"
                          style={{ width: '40%', height: '24px', marginBottom: '8px' }}
                        ></div>
                        <div className="skeleton-loader" style={{ width: '100px', height: '20px' }}></div>

                        <hr className="skeleton-loader" />

                        <div
                          className="skeleton-loader"
                          style={{ width: '40%', height: '24px', marginBottom: '8px' }}
                        ></div>
                        <div className="skeleton-loader" style={{ width: '70%', height: '16px' }}></div>

                        <hr className="skeleton-loader" />

                        <div
                          className="skeleton-loader"
                          style={{ width: '40%', height: '24px', marginBottom: '8px' }}
                        ></div>
                        <div className="skeleton-loader" style={{ width: '80%', height: '16px' }}></div>
                        <div
                          className="skeleton-loader"
                          style={{ width: '150px', height: '36px', marginTop: '12px' }}
                        ></div>

                        <hr className="skeleton-loader" />

                        <div
                          className="skeleton-loader"
                          style={{ width: '40%', height: '24px', marginBottom: '8px' }}
                        ></div>
                        <div
                          className="skeleton-loader"
                          style={{ width: '80%', height: '16px', marginBottom: '16px' }}
                        ></div>

                        <div className="skeleton-loader" style={{ width: '100%', height: '80px' }}></div>

                        <div className="d-flex justify-content-end mt-4">
                          <div className="skeleton-loader" style={{ width: '160px', height: '40px' }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SurveyWrapperInner>
          </StyledGuestDetails>
        </SurveyWrapper>
      ) : (
        <SurveyWrapper
          marshaCode={marshaCode}
          backgroundImage={backgroundImageUrl}
          className="brand-css common-color-set"
          colorScheme={brandCdSetPage}
          alternateId={alternateCID}
          productInfo={marshaCode}
          formPageName="Guest Details"
          formName="Prearrival Travel Form"
          prearrival_form_amenities_added_to_plan={formData.prearrivalformamenitiesaddedtoplan}
          prearrival_form_booking_confirmation_id={combinedValue}
          env_api_tile_error_info={errorInfo}
          form_prearrival_questions_complete={form_prearrival_questions_complete}
          beforeSuveryWrapperOuter={props?.model?.beforeSuveryWrapperOuter}
          afterSuveryWrapperOuter={props?.model?.afterSuveryWrapperOuter}
        >
          {!isShowError ? (
            <StyledGuestDetails
              className={styleClass}
              data-testid="guest-details"
              data-component-name="o-account-guestDetails"
            >
              <SurveyWrapperInner
                beforeSuveryWrapperInner={props?.model?.beforeSuveryWrapperInner}
                afterSuveryWrapperInner={props?.model?.afterSuveryWrapperInner}
              >
                <div className="guest-details-page">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div>
                          <div className="guest-detail-page-wrapper d-flex justify-content-start align-items-start flex-column container col-12 col-xl-10 ">
                            <div className="d-flex top-right-content">
                              <Text
                                element={Types.tags.paragraph}
                                fontSize={Types.size.medium}
                                dangerouslySetInnerHTML={{ __html: fragmentString6 }}
                                customClass="mb-2"
                              ></Text>

                              <Text
                                element={Types.tags.paragraph}
                                fontSize={Types.size.medium}
                                dangerouslySetInnerHTML={{ __html: fragmentString5 }}
                                customClass="pl-2"
                              ></Text>
                            </div>
                            <Heading
                              variation={Types.headingType.title}
                              fontSize={Types.size.large}
                              element={Types.tags.h1}
                              titleText={title}
                              disableCustomClickTrack={true}
                            />
                            {/* {!contentBottomLoadFlag && (
                            <>
                              <Text
                                element={Types.tags.paragraph}
                                fontSize={Types.size.small}
                                dangerouslySetInnerHTML={{ __html: fragmentString3 }}
                              ></Text>
                              <div className="d-flex justify-content-between mb-3">
                                <div className="d-item-container">
                                  <div className="d-item">

                                    <Text
                                      element={Types.tags.paragraph}
                                      fontSize={Types.size.medium}
                                      dangerouslySetInnerHTML={{ __html: fragmentString4 }}
                                      customClass="mb-2 bold"
                                    ></Text>
                                  </div>
                                  <div className="d-item">
                                    <Text
                                      element={Types.tags.paragraph}
                                      fontSize={Types.size.medium}
                                      dangerouslySetInnerHTML={{ __html: fragmentString6 }}
                                    ></Text>
                                  </div>
                                </div>
                                <div className="d-item-container">
                                  <div className="d-item">
                                    <Text
                                      element={Types.tags.paragraph}
                                      fontSize={Types.size.medium}
                                      dangerouslySetInnerHTML={{ __html: fragmentString5 }}
                                      customClass="mb-2"
                                    ></Text>
                                  </div>
                                  <div className="d-item">
                                    <Text
                                      element={Types.tags.paragraph}
                                      fontSize={Types.size.medium}
                                      dangerouslySetInnerHTML={{ __html: fragmentString7 }}
                                    ></Text>
                                  </div>
                                </div>
                              </div>
                              <Text
                                element={Types.tags.div}
                                fontSize={Types.size.medium}
                                dangerouslySetInnerHTML={{ __html: fragmentString8 }}
                                customClass={'header-note'}
                              ></Text>
                            </>
                          )} */}
                            <Text
                              element={Types.tags.paragraph}
                              fontSize={Types.size.small}
                              dangerouslySetInnerHTML={{ __html: fragmentString14 }}
                              customClass="summary-section"
                            ></Text>
                            <hr className="hr-toggle" />
                            {/* Trip Contact Preference */}
                            <Heading
                              variation={Types.headingType.title}
                              fontSize={Types.size.extraSmall}
                              element={Types.tags.h3}
                              titleText={labels.contactPreferencesHeading}
                              disableCustomClickTrack={true}
                            />
                            <Text
                              element={Types.tags.div}
                              fontSize={Types.size.medium}
                              dangerouslySetInnerHTML={{ __html: fragmentString11 }}
                              customClass="mb-1 subTitle twoTitle"
                            ></Text>
                            {isMobileViewPort ? renderFormTripContact() : renderFormTripContactguestDetailV2()}

                            {renderErrorMessage()}
                            <hr className="hr-toggle" />

                            <Heading
                              variation={Types.headingType.title}
                              fontSize={Types.size.extraSmall}
                              element={Types.tags.h3}
                              titleText={labels.arrivalHeading}
                              disableCustomClickTrack={true}
                            />
                            <Text
                              element={Types.tags.paragraph}
                              fontSize={Types.size.medium}
                              dangerouslySetInnerHTML={{ __html: labels.subTitle20 }}
                              customClass="mb-3 subTitle"
                            ></Text>
                            <div
                              className={`time-picker d-flex flex-column toggle-arrival-hr ${
                                hasError.arrivalAnticipateError ? 'has-error' : ''
                              }`}
                            >
                              <TimePicker
                                id={`${inputId}-PreferredDateArrival`}
                                name="PreferredDateArrival"
                                time={selectedTimes.localtime || formData?.arrival_anticipate_time}
                                onChange={newTime => handleTimeChange(newTime, 'localtime')}
                                hasError={hasError.arrivalAnticipateError}
                              />
                              <Text
                                element={Types.tags.paragraph}
                                fontSize={Types.size.small}
                                dangerouslySetInnerHTML={{ __html: fragmentString2 }}
                                customClass="time-text mt-2 mb-4"
                              ></Text>
                              {hasError.arrivalAnticipateError && (
                                <div className="error-container ">
                                  <span className="error-icon">
                                    <i className="icon-alert"></i>
                                  </span>
                                  <Text
                                    element={Types.tags.paragraph}
                                    fontSize={Types.size.extraSmall}
                                    customClass={`error-message time`}
                                    dangerouslySetInnerHTML={{ __html: labels.arrivalTimeErrorMessage }}
                                  ></Text>
                                </div>
                              )}
                            </div>
                            {!selectedTimes.localtime && formData?.arrival_anticipate_time && renderErrorMessage()}

                            <hr className="hr-toggle" />
                            {/* Additional Guest */}

                            <div className="toggle-section">
                              <Heading
                                variation={Types.headingType.title}
                                fontSize={Types.size.extraSmall}
                                element={Types.tags.h3}
                                titleText={labels.additionalGuestsHeading}
                                disableCustomClickTrack={true}
                                data-testid="SubGuest Description"
                              />

                              <div
                                className={`d-flex align-items-center flex-row switch-toggle ${
                                  travelingWithChildren === 'Yes' ? 'mb-3' : ''
                                }`}
                              >
                                <span className="toggle-text-no">No</span>
                                <Switch
                                  toggleId="add_additional_guest_toggleswitch"
                                  toggleName="add_additional_guest_toggle"
                                  onChange={() => toggleVisibility('div21')}
                                  selected={formData.add_additional_guest === 'Yes'}
                                >
                                  <span className="sr-only">Label for Additional Guests</span>
                                </Switch>
                                <span className="toggle-text">Yes</span>
                              </div>
                            </div>

                            {formData.add_additional_guest === 'Yes' && (
                              <>
                                <Text
                                  element={Types.tags.paragraph}
                                  fontSize={Types.size.medium}
                                  dangerouslySetInnerHTML={{ __html: fragmentString9 }}
                                  customClass="mb-3 subTitle guestSubtitle"
                                />

                                {/** Adding molecule */}
                                <DynamicAddSection ref={sectionRef} mode="guestChild" />

                                <div className="d-flex justify-content-between align-items-center flex-row w-auto mb-2">
                                  {renderFormAddGuest()}

                                  {!(
                                    formData?.property_config?.adults_only_flag === 'Y' ||
                                    props?.property_config?.adults_only_flag === 'Y'
                                  ) && renderFormAddChildren()}
                                </div>
                              </>
                            )}
                            <hr className="hr-toggle" />

                            {/* Travelling with pets  */}
                            {showPetSection && (
                              <>
                                <div className="toggle-section">
                                  <Heading
                                    variation={Types.headingType.title}
                                    fontSize={Types.size.extraSmall}
                                    element={Types.tags.h3}
                                    titleText={labels.travelingWithPetsHeading}
                                    disableCustomClickTrack={true}
                                    data-testid="travellingPets title"
                                  />
                                  <div
                                    className={`d-flex align-items-center flex-row switch-toggle ${
                                      travelingWithPets === 'Yes' ? '' : ''
                                    }`}
                                  >
                                    <span className="toggle-text-no">No </span>
                                    <Switch
                                      toggleId="pet_details_toggleswitch"
                                      toggleName="pet_details_toggleswitch"
                                      onChange={() => toggleVisibility('div2')}
                                      selected={travelingWithPets === 'Yes'}
                                    >
                                      <span className="sr-only">Traveling with Pets</span>
                                    </Switch>
                                    <span className="toggle-text"> Yes</span>
                                  </div>
                                </div>
                                {travelingWithPets === 'Yes' && (
                                  <Text
                                    element={Types.tags.paragraph}
                                    fontSize={Types.size.medium}
                                    dangerouslySetInnerHTML={{ __html: fragmentString15 }}
                                    customClass="mb-3 subTitle guestSubtitle"
                                  ></Text>
                                )}

                                {travelingWithPets === 'Yes' && (
                                  <>
                                    <div className="col-md-6 p-0 mb-3">
                                      <p>Pets Policy at {propertyName} </p>
                                      <ul className="pet-form">
                                        <li>Pets Welcome</li>
                                        {petFeeData?.property?.policies?.petsPolicyDescription && (
                                          <li>{petFeeData.property.policies.petsPolicyDescription}</li>
                                        )}
                                        {petFeeData?.property?.policies?.petsPolicyDetails[0]?.additionalPetFee && (
                                          <li>
                                            Additional Pet Fee{' '}
                                            {petFeeData.property.policies.petsPolicyDetails[0].additionalPetFeeType}:{' '}
                                            {convertToPrice(
                                              petFeeData.property.policies.petsPolicyDetails[0].additionalPetFee,
                                              petFeeData.property.basicInformation.currency
                                            )}
                                          </li>
                                        )}
                                        {petFeeData?.property?.policies?.petsPolicyDetails[0]?.nonRefundableFee && (
                                          <li>
                                            Non-Refundable Pet Fee{' '}
                                            {petFeeData.property.policies.petsPolicyDetails[0].nonRefundableFeeType}:{' '}
                                            {convertToPrice(
                                              petFeeData.property.policies.petsPolicyDetails[0].nonRefundableFee,
                                              petFeeData.property.basicInformation.currency
                                            )}
                                          </li>
                                        )}
                                        {petFeeData?.property?.policies?.petsPolicyDetails[0]?.refundableFee && (
                                          <li>
                                            Refundable Pet Fee{' '}
                                            {petFeeData.property.policies.petsPolicyDetails[0].refundableFeeType}:{' '}
                                            {convertToPrice(
                                              petFeeData.property.policies.petsPolicyDetails[0].refundableFee,
                                              petFeeData.property.basicInformation.currency
                                            )}
                                          </li>
                                        )}
                                        {petFeeData?.property?.policies?.petsPolicyDetails[0]?.numberAllowed && (
                                          <li>
                                            Maximum Number of Pets in Room:{' '}
                                            {petFeeData.property.policies.petsPolicyDetails[0].numberAllowed}
                                          </li>
                                        )}
                                        {petFeeData?.property?.policies?.petsPolicyDetails[0]?.maxWeight && (
                                          <li>
                                            Maximum Pet Weight:{' '}
                                            {petFeeData.property.policies.petsPolicyDetails[0].maxWeight}
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                    <DynamicAddSection ref={sectionPetRef} mode="pet" />
                                    {renderFormPetDetail()}
                                  </>
                                )}

                                <hr className="hr-toggle" />
                              </>
                            )}

                            {/* Accessibility */}

                            <div className="toggle-section">
                              <Heading
                                variation={Types.headingType.title}
                                fontSize={Types.size.extraSmall}
                                element={Types.tags.h3}
                                titleText={labels.needsHeading}
                                disableCustomClickTrack={true}
                                data-testid="accessibility title"
                              />
                              <div
                                className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                                  accessibilityNeedsToggle === 'Yes' && 'mb-2'
                                }`}
                              >
                                <span className="toggle-text-no">No </span>
                                <Switch
                                  toggleId="accessibilityNeeds_toggle"
                                  toggleName="accessibilityNeeds_toggle"
                                  onChange={() => toggleVisibility('div22')}
                                  selected={formData.accessibilityNeeds_toggle === 'Yes'}
                                >
                                  <span className="sr-only">Accessibility Disability Needs</span>
                                </Switch>
                                <span className="toggle-text"> Yes</span>
                              </div>
                            </div>
                            {accessibilityNeedsToggle === 'Yes' && (
                              <>
                                <div className={`d-flex align-items-center flex-row switch-toggle occasionToggle mb-2`}>
                                  <p
                                    data-component-name="a-ui-library-Text"
                                    className="t-font-m mb-3 subTitle m-0"
                                    data-testid="ui-library-Text"
                                  >
                                    Do you or any of your guests have any accessibility / disability needs?
                                  </p>
                                </div>
                                {formData.accessiblity_needs === 'Yes' && renderFormAccessibility()}
                              </>
                            )}

                            <hr className="hr-toggle" />
                            {/* {Trip contact Section } */}

                            {/* Special Occasion */}
                            <div className="toggle-section">
                              <Heading
                                variation={Types.headingType.title}
                                fontSize={Types.size.extraSmall}
                                element={Types.tags.h3}
                                titleText={labels.specialOccasionHeading}
                                disableCustomClickTrack={true}
                              />

                              <div
                                className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                                  formData.specialOccasion_toggle === 'Yes' && 'mb-2'
                                }`}
                              >
                                <span className="toggle-text-no">No </span>
                                <Switch
                                  toggleId="specialOccasion_toggle"
                                  toggleName="specialOccasion_toggle"
                                  onChange={() => toggleVisibility('div23')}
                                  selected={formData.specialOccasion_toggle === 'Yes'}
                                >
                                  <span className="sr-only">Special Occasion</span>
                                </Switch>

                                <span className="toggle-text"> Yes</span>
                              </div>
                            </div>

                            {formData.specialOccasion_toggle === 'Yes' && (
                              <>
                                <Text
                                  element={Types.tags.paragraph}
                                  fontSize={Types.size.medium}
                                  dangerouslySetInnerHTML={{ __html: fragmentString12 }}
                                  customClass="mb-2 subTitle"
                                />
                                {renderFormSpecialOccasion()}
                              </>
                            )}

                            <hr className="hr-toggle" />
                            {/* Arrival time section */}

                            {/* Transportation Details */}
                            <div className="toggle-section">
                              <Heading
                                variation={Types.headingType.title}
                                fontSize={Types.size.extraSmall}
                                element={Types.tags.h3}
                                titleText={labels.transportationHeading}
                                disableCustomClickTrack={true}
                              />

                              <div
                                className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                                  formData.arrival_method_toggle === 'Yes' && 'mb-2'
                                }`}
                              >
                                <span className="toggle-text-no">No </span>
                                <Switch
                                  toggleId="transportation_method_toggle1"
                                  toggleName="transportation_method_toggle"
                                  onChange={() => toggleVisibility('div26')}
                                  selected={formData.transportation_method_toggle === 'Yes'}
                                >
                                  <span className="sr-only">Transportation Details</span>
                                </Switch>
                                <span className="toggle-text"> Yes</span>
                              </div>
                            </div>

                            {formData.transportation_method_toggle === 'Yes' && (
                              <>
                                {renderFormTripDetails()}
                                {showVariableErrorMessage && renderVariableChangeErrorMessage()}
                              </>
                            )}
                            <hr className="hr-toggle" />
                            {/* Additional Requests */}
                            <div className="toggle-section">
                              <Heading
                                variation={Types.headingType.title}
                                fontSize={Types.size.extraSmall}
                                element={Types.tags.h3}
                                titleText={labels.additionalRequestsHeading}
                                disableCustomClickTrack={true}
                              />

                              <div
                                className={`d-flex align-items-center flex-row switch-toggle occasionToggle ${
                                  formData.additional_requests_toggle === 'Yes' && 'mb-2'
                                }`}
                              >
                                <span className="toggle-text-no">No </span>
                                <Switch
                                  toggleId="additional_requests_toggle"
                                  toggleName="additional_requests"
                                  onChange={() => toggleVisibility('div27')}
                                  selected={formData.additional_requests_toggle === 'Yes'}
                                >
                                  <span className="sr-only">Additional Requests</span>
                                </Switch>
                                <span className="toggle-text"> Yes</span>
                              </div>
                            </div>
                            <hr className={`${additionalRequestsToggleShow}`} />
                            {formData.additional_requests_toggle === 'Yes' && (
                              <>
                                <Text
                                  element={Types.tags.paragraph}
                                  fontSize={Types.size.medium}
                                  dangerouslySetInnerHTML={{ __html: fragmentString13 }}
                                  customClass="mb-3 subTitle"
                                  data-testid="GuestDetails Description"
                                />
                                <div className="col-md-6 p-0">
                                  <TextArea
                                    id={`${inputId}-additionalRequestNotesArea`}
                                    key="additionalRequestNotesArea"
                                    name="additionalRequestNotesArea"
                                    label="additionalRequestNotesArea"
                                    placeHolderText="Please add notes here"
                                    getInputValue={val => {
                                      setFormData({ ...formData, additional_requests: removeXSSScripts(val) });
                                    }}
                                    inputValue={formData.additional_requests}
                                    maxLength={255}
                                    messageError={errorMessage1}
                                  />
                                </div>
                              </>
                            )}

                            <div className="align-items-end flex-column d-flex col-12 p-0 mt-4 btn-center">
                              <Button
                                className="m-button-m m-button-primary custom-btn mx-0 continue-btn"
                                type={Types.ButtonTypeVariation.Button}
                                buttonCopy="Continue"
                                callback={() => {
                                  sectionRef.current?.validate();
                                  sectionPetRef.current?.validate();
                                  handleAddFormData();
                                  ValidateMandateData(false);
                                }}
                                isDisabled={
                                  !!(
                                    hasError.arrivalAnticipateError ||
                                    hasError.arrivalMethodError ||
                                    hasError.departureMethodError ||
                                    hasError.arrivalDateError ||
                                    hasError.departureDateError ||
                                    hasError.arrivalTime ||
                                    hasError.departureTime ||
                                    formValidation
                                  )
                                }
                              ></Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SurveyWrapperInner>
            </StyledGuestDetails>
          ) : (
            <ErrorDetail
              hotelEmail={props.hotelEmail}
              hotelPhoneNumber={props.hotelPhoneNumber}
              confirmationNumber={props?.reservation?.confirmationNumber}
              errorVal={errorMsg}
              errorData={props.productSpecificResponse?.errorData?.accDown}
            />
          )}
        </SurveyWrapper>
      )}
    </div>
  );
};

export const GuestDetailsWrapperConfig = {
  emptyLabel: 'GuestDetail',
  isEmpty: false,
  resourceType: `mi-aem-prearrival/components/guestdetails`,
};
/* eslint-disable  @typescript-eslint/no-explicit-any */
export const GuestDetailsEditable = (props: any) => {
  return (
    <EditableComponent {...props} config={GuestDetailsWrapperConfig}>
      <div data-testid="guest-details-accounts">
        <GuestDetails {...props} />
      </div>
    </EditableComponent>
  );
};
